<template>
  <div class="paperless" @click="clearViewport">
    <!--    挂单、收款、结算    -->
    <orderPending :drawer="drawer" :type="drawerType" @upDrawer="upDrawer" @clearOrderInfo="clearOrderInfo"
      ref="orderPending" :orderData="orderData" :departmentList="departmentPerformanceList"
      :currentSelectedMember="currentSelectedMember" :currentlySelectedCard="currentlySelectedCard"
      :orderTypes="orderTypes" :orderPrice="orderPrice" :DepartmentalList.sync="DepartmentalPerformance"
      :isDepartmentalPerformance="isDepartmentalPerformance" @updateDepartmentalList="updateDepartmentalList"
      @selectMemberInformation="selectMemberInformation" @updateMemberInformation="updateMemberInformation"
      :orderDataHasBeenPosted="orderDataHasBeenPosted" @updateTag="updateTag"
      @getTheListOfOrderingData="getTheListOfOrderingData" @updateOrderData="updateOrderData"
      @getThePendingOrderNumber="getThePendingOrderNumber" @modifyADesignation="setModifyADesignation"
      @research="research"></orderPending>

    <!--   左侧导航栏     -->
    <div class="navigationBar" :style="drawer ? { display: 'none' } : { display: 'block' }">
      <div class="logo"><img src="https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_logo_02cai.png"
          alt="logo" /></div>
      <template v-if="storePerformanceAuthority || employeePerformanceAuthority">
        <div class="nva-item statement"><span class="iconfont icon-baobiao"></span> <span>报表</span></div>
        <div class="reportPopUp">
          <template v-if="storePerformanceAuthority">
            <div class="reportPopUp-item" @click.stop="openWindows($router.resolve({ name: 'money' }))">门店业绩</div>
          </template>
          <template v-if="employeePerformanceAuthority">
            <div class="reportPopUp-item" @click.stop="openWindows($router.resolve({ name: 'data' }))">员工数据</div>
          </template>
        </div>
      </template>
      <template v-if="orderManagementAuthority">
        <div class="nva-item orderData" @click.stop="openWindows($router.resolve({ name: 'order' }))"><span
            class="iconfont icon-dingdan"></span> <span>订单</span></div>
      </template>
      <template v-if="memberCenterManagementRights">
        <div class="nva-item" @click.stop="openWindows($router.resolve({ name: 'member' }))"><span
            class="iconfont icon-yuangong"></span> <span>顾客</span></div>
      </template>
      <template>
        <div class="nva-item" @click.stop="turnOnTheClock" v-if="whetherToEnableThecDInSetting"><span
            class="iconfont icon-daka"></span> <span>打卡</span></div>
      </template>

      <div class="operation">
        <div class="fullScreenDisplay" @click.stop="switchDisplay"><span v-show="isPic" class="iconfont icon-T"></span>
          <span v-show="!isPic" class="iconfont icon-yingyong"></span>
        </div>

        <div class="fullScreenDisplay" @click.stop="Fkey"><span v-show="!flag" class="iconfont icon-quanping"></span>
          <span v-show="flag" class="iconfont icon-suoxiao"></span>
        </div>
      </div>
    </div>
    <!-- 左边主要内容部分 -->
    <div class="paperlessLeft">
      <!-- 查询项目 -->
      <div v-if="searchInputBoxShow" class="itemQueryCt"
        style="height: 40px;display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 15px;">
        <div class="" data-tag="employeeViewport" style="height: 40px;display: flex;">
          <el-input style="margin: auto;" data-tag="employeeViewport" placeholder="请输入项目编号" ref="itemQueryRef"
            v-model="queryItem" size="medium" @keyup.native="filterItemData" @keydown.enter.native="selectFirstItem">
            <!-- <el-button slot="prepend" icon="el-icon-search"></el-button> -->
          </el-input>
        </div>
        <!-- 关闭按钮 -->
        <el-button type="text" icon="el-icon-close" @click="closeSearch()"
          style="color: grey; font-size: 20px; padding: 0;"></el-button>
      </div>

      <!--     标题栏      -->
      <div class="titleBar">
        <div class="selectionbar">
          <div class="selectionbar-item" v-for="item in selectionBar" :key="item.id">
            <span :class="item.id === filterType ? 'active' : ''" @click="switchingType(item)">{{ item.name }}</span>
          </div>
        </div>
        <!--      操作类型      -->
        <div class="operationType">
          <div class="operationType-item" v-for="item in operationType" :key="item.id" @click="operation(item)">
            <div class="content">
              <span :class="'iconfont ' + item.icon"></span> <span>{{ item.name }}</span>
              <!--      左上角      -->
              <span class="topLeftCorner" v-if="item.id === 1">{{ orderDataNumber }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--     标题栏     -->
      <div class="nav-body">
        <template>
          <div class="projectType-box">
            <el-skeleton animated style="width: 100%;" :loading="projectTypeList.length === 0">
              <template slot="template">
                <div style="display: flex; flex-direction: column;">
                  <el-skeleton-item variant="h1" style="width: 600px; margin-top: 15px" />
                  <el-skeleton-item variant="h1" style="width: 300px; margin-top: 30px" />
                </div>
              </template>

              <template>
                <div class="projectType">
                  <div :class="index === projectType ? 'projectType-item active' : 'projectType-item'"
                    v-for="(item, index) in projectTypeList" :key="item.id" @click="switchItems(item, index)">
                    <span>{{ item.dictName }}</span>
                  </div>
                </div>
                <!--       字母筛选        -->
                <div class="alphabeticScreening">
                  <div :class="item === letter ? 'alphabeticScreening-item active' : 'alphabeticScreening-item'"
                    v-for="item in alphabeticScreening" :key="item" @click="switchingFilterCondition(item)">{{
                      item.toUpperCase() }}</div>
                </div>
              </template>
            </el-skeleton>
          </div>
        </template>
      </div>
      <!--     项目       -->
      <el-skeleton animated style="width: 100%; height: 100%" :loading="projectList.length === 0">
        <template v-if="isPic">
          <div class="content-body-pic">
            <div :class="theProjectSelectsGlobalListening === index ? 'content-body-item active' : 'content-body-item'"
              data-tag="openEmployeeViewport" v-for="(item, index) in projectList" :key="index"
              @click="option(item, undefined, index)">
              <div class="projectName" data-tag="openEmployeeViewport" :style="{
                backgroundImage: `url(${item.picture || 'https://gd3.alicdn.com/imgextra/i3/62247684/O1CN01rLN5Hl26dKB3MoYGU_!!62247684.jpg'})`,
                backgroundSize: '100% 100%',
              }">
                <span data-tag="openEmployeeViewport" class="itemNumber">{{ filterType === 0 ? item.packageCode :
                  item.productCode }}</span>

                <template v-if="productInventoryNumberPermission">
                  <span data-tag="openEmployeeViewport" class="inventory" v-show="item.stock !== undefined">
                    <i>库存</i> <i :class="item.stock <= 0 ? 'active pic_active' : 'pic_active'">{{ item.stock }}</i>
                  </span>
                </template>
              </div>
              <div class="projectInfo" data-tag="openEmployeeViewport">
                <span data-tag="openEmployeeViewport" :class="item.stock <= 0 ? 'active' : ''">{{ filterType === 0 ?
                  textLength(item.packageName) : textLength(item.productName) }}</span>
                <div class="priceInventory" data-tag="openEmployeeViewport">
                  <span data-tag="openEmployeeViewport">￥{{ item.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="content-body">
            <div :class="theProjectSelectsGlobalListening === index ? 'content-body-item active' : 'content-body-item'"
              data-tag="openEmployeeViewport" v-for="(item, index) in projectList" :key="index"
              @click="option(item, undefined, index)">
              <div class="projectName" data-tag="openEmployeeViewport">
                <span data-tag="openEmployeeViewport">{{ filterType === 0 ? item.packageCode : item.productCode
                }}</span> <span data-tag="openEmployeeViewport" :class="item.stock <= 0 ? 'active' : ''">{{ filterType
                    === 0 ? textLength(item.packageName) : textLength(item.productName) }}</span>
              </div>
              <div class="projectInfo" data-tag="openEmployeeViewport">
                <span data-tag="openEmployeeViewport">￥{{ item.price }}</span>
                <template v-if="productInventoryNumberPermission">
                  <span data-tag="openEmployeeViewport" v-show="item.stock !== undefined">
                    <i>库存:</i> <i :class="item.stock <= 0 ? 'active' : ''">{{ item.stock }}</i>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>
      <!--     员工列表      -->
      <div class="employeeList" ref="employeeRef" data-tag="employeeViewport">
        <div class="title" data-tag="employeeViewport">
          <div class="title-input" data-tag="employeeViewport"><input type="text" placeholder="员工编号"
              data-tag="employeeViewport" v-model.trim="employeeNumber" @input="searchForEmployees" @focus="noDisplay"
              @blur="permittedDisplay" /></div>
          <span class="iconfont icon-guanbi" data-tag="employeeViewport" @click="closeEmployeeViewport"></span>
        </div>
        <template v-if="employeeList.length">
          <div class="con" v-for="item in employeeList" :key="item.postId" data-tag="employeeViewport">
            <div class="position" data-tag="employeeViewport">
              <span class="iconfont icon-zhiwei" data-tag="employeeViewport"></span> <span
                data-tag="employeeViewport">{{ item.postName }}</span>
            </div>
            <div class="staff" data-tag="employeeViewport">
              <div :class="subItem.label ? 'staff-item active' : 'staff-item'" v-for="subItem in item.positionEmployee"
                :key="subItem.id" @click="selectEmployees(subItem)" data-tag="employeeViewport">
                <span data-tag="employeeViewport">{{ subItem.employeeNo }}</span> <span data-tag="employeeViewport">{{
                  subItem.employeeName }}</span> <i v-show="subItem.numberOfAdditions" class="iconfont icon-chacha"
                  @click.stop="removeAnEmployee(subItem.employeeNo)"></i>
                <i v-show="subItem.numberOfAdditions">{{ subItem.numberOfAdditions }}</i>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div data-tag="employeeViewport" style="text-align: center"><span class="iconfont icon-wushuju"></span><span
              style="display: inline-block; margin: 10px 0 0; color: #7c7c7c;">暂无员工</span></div>
        </template>
      </div>
      <!--     会员列表      -->
      <div class="member-box" ref="memberBoxRef" v-show="!currentSelectedMember.id">
        <div class="memberEmployee" ref="memberEmployeeRef" data-tag="memberViewport">
          <div class="member-title" data-tag="memberViewport"><span data-tag="memberViewport">确认会员</span> <span
              @click.self="research" class="iconfont icon-closel"></span></div>
          <!--         会员信息          -->
          <div class="member-content" data-tag="memberViewport">
            <div :class="item.cardShow ? 'member-content-item' : 'member-content-item activeHover'"
              data-tag="memberViewport" v-for="(item, index) in memberList" :key="item.id"
              @click.stop="selectMemberInformation(item)">
              <div class="member-headers" data-tag="memberViewport"><svg-icon class="default_head"
                  icon-class="default_head" :style="item.gzhState ? { color: '#55a532' } : { color: 'red' }"></svg-icon>
              </div>
              <div class="member-info" data-tag="memberViewport">
                <div class="member-user" data-tag="memberViewport">
                  <div class="member-name" data-tag="memberViewport">
                    <span data-tag="memberViewport" v-highlight="resetMemberName(item)">{{ item | filterMemberName
                    }}</span>
                  </div>

                  <div class="member-integral" data-tag="memberViewport">
                    <span class="iconfont icon-huiyuanqia" data-tag="memberViewport"></span> <span
                      data-tag="memberViewport">会员号:</span> <span data-tag="memberViewport"
                      v-highlight="item.memberNo">{{
                        item.memberNo }}</span>
                  </div>

                  <div class="member-phone" data-tag="memberViewport">
                    <span class="iconfont icon-shoujihao" data-tag="memberViewport"></span> <span
                      data-tag="memberViewport" v-highlight="item.memberMobile">{{ item.memberMobile }}</span>
                  </div>
                  <div class="member-integral" data-tag="memberViewport">
                    <span class="iconfont icon-jifen" data-tag="memberViewport"></span> <span
                      data-tag="memberViewport">积分:</span> <span data-tag="memberViewport">{{ item.pointValue }}</span>
                  </div>

                  <span :class="item.cardShow ? 'iconfont icon-zhankai' : 'iconfont icon-shouqi'"
                    data-tag="memberViewport" @click.self.stop="expansionCardDetails(item, index)"></span>
                </div>

                <!--            卡列表              -->
                <div :class="item.cardShow ? 'member-card active' : 'member-card'" data-tag="memberViewport"
                  v-if="item.currentMembershipCardList">
                  <div :class="item.cardShow ? 'member-card-item activeHover' : 'member-card-item'"
                    data-tag="memberViewport" v-for="subItem in item.currentMembershipCardList"
                    :key="subItem.tmemberCard.id" @click.stop="selectMemberInformation(item, subItem)">
                    <div class="card-pic" data-tag="memberViewport">
                      <img :src="subItem.tmemberCard.cardTypeCode | filterCardPic('img')" data-tag="memberViewport"
                        height="30px" alt="" />
                      <div class="card-info" data-tag="memberViewport">
                        <span data-tag="memberViewport">{{ subItem.tmemberCard.cardName }} {{ subItem.tmemberCard.cardNo
                          ?
                          `（${subItem.tmemberCard.cardNo}）` : "" }}</span> <span data-tag="memberViewport">有效期:
                          无限期</span>
                      </div>
                    </div>
                    <div class="cardBalance" data-tag="memberViewport">
                      <!---   余次   --->
                      <template v-if="subItem.tmemberCard.cardTypeCode === 3">
                        <span data-tag="memberViewport">卡余次：</span> <span data-tag="memberViewport">{{
                          isRemaindTotalCountInfinite(subItem.tmemberCard.remaindTotalCount) }}次</span>
                      </template>

                      <!---   余额   --->
                      <template v-else>
                        <span data-tag="memberViewport">卡余额：</span> <span data-tag="memberViewport" class="balance">￥{{
                          subItem.tmemberCard.initAmount }}</span>

                        <span data-tag="memberViewport">赠金：</span> <span data-tag="memberViewport" class="balance">￥{{
                          subItem.tmemberCard.givenAmount }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--     录单标识       -->
      <div class="recordingIdentification" v-show="recordOrNot">
        <span>{{ handBrand.split(":")[1] ? "订单号" : "手牌号" }}</span> <span>#{{ handBrand.split(":")[0] }}</span>
        <span>录单中...</span> <span @click.stop="cancelBooking">取消</span>
      </div>
    </div>
    <!-- 右边订单列表部分 -->
    <div class="paperlessRight" ref="paperlessRightRef">
      <!--      用户信息      -->
      <template v-if="!currentSelectedMember.id">
        <div class="searchUserName" data-tag="clear" ref="memberInformationRef">
          <div class="contentInput" data-tag="clear">
            <!--  @compositionend="searchMembership" @compositionstart="searchMembership" 虚拟假盘监听 防止拼写后选择事件无法触发 -->
            <input type="text" placeholder="手机号码/会员号/会员姓名/会员昵称" data-tag="clear" v-model="searchContent"
              @focus="memberSearchFocus" @compositionend="searchMembership" @compositionstart="searchMembership"
              @keyup="searchMembership" @blur="queryItem = ''" />
            <span class="iconfont icon-chazhaoyonghu" data-tag="clear"></span>
          </div>
        </div>
      </template>
      <!--        会员信息          -->
      <template v-else>
        <div class="memberInformation" ref="memberInformationRef">
          <div class="userInfo">
            <div class="user-header-pic" @click="jumpDetails"><img
                :src="currentSelectedMember.id ? currentSelectedMember.memberPortrait || 'https://s1.ax1x.com/2018/12/22/FykFr4.png' : 'https://s1.ax1x.com/2018/12/22/FykFr4.png'"
                alt="" /></div>
            <div class="user-info">
              <div class="usercontent">
                <span class="name">{{ currentSelectedMember.memberName }}</span> <span class="phone">{{
                  currentSelectedMember.memberMobile }}</span>
                <span class="membershipNumber">
                  <i>#{{ currentSelectedMember.memberNo }}</i>
                </span>
              </div>

              <div class="rechargeAndOpenACard">
                <span @click.stop="membershipCardOpening(true)">开卡</span>
                <span style="text-decoration: none; display: flex; align-items: center">
                  <template v-if="storeGlobalSettingStatus('启用会员积分')">
                    <svg class="icon" aria-hidden="true">
                      <use href="#icon-jifen3"></use>
                    </svg> <i style="margin: 0 5px; color: #f683a2; font-weight: bold">{{
                      currentSelectedMember.pointValue }}</i>
                    <i class="iconfont icon-zengjia-fang" style="font-size: 20px; margin: 0 5px"
                      @click.stop="modifiedIntegral('add')"></i> <i class="iconfont icon-jianshao-fang"
                      style="font-size: 20px; margin: 0 5px" @click.stop="modifiedIntegral('remove')"></i>
                  </template>
                </span>
              </div>
            </div>
            <span class="iconfont icon-chazhaoyonghu" @click.self="research(true)"></span>
          </div>
          <!--         用户会员卡列表           -->
          <div class="cardList">
            <div
              :class="currentlySelectedCard.tmemberCard.id === item.tmemberCard.id ? 'cardList-item active' : 'cardList-item'"
              v-for="item in currentSelectedMember.currentMembershipCardList" :key="item.tmemberCard.id"
              @click="selectMembershipCard(item)">
              <span>{{ item.tmemberCard.cardName }}</span>
            </div>
          </div>
          <!--         会员卡信息          -->
          <template v-if="currentlySelectedCard">
            <div class="otherOperations">
              <img :src="currentlySelectedCard.tmemberCard.cardTypeCode | filterCardPic('bg')" alt="" />
              <div class="card-Info-content">
                <div class="card-title">
                  <div class="card-info-name">
                    <span>{{ currentlySelectedCard.tmemberCard.cardName }}</span> <span class="infocard">{{
                      currentlySelectedCard.tmemberCard.cardTypeName }}</span>
                    <span class="infocard"
                      v-if="currentlySelectedCard.tmemberCard.cardTypeCode !== 3 && currentlySelectedCard.tmemberCard.cardTypeCode !== 0">开卡日期</span>
                  </div>

                  <template
                    v-if="currentlySelectedCard.tmemberCard.cardTypeCode === 3 || currentlySelectedCard.tmemberCard.cardTypeCode === 0">
                    <div class="cardBalance">
                      <div class="kagin">
                        <div class="cardBalance-content">
                          <span>卡余次:</span> <span>{{
                            isRemaindTotalCountInfinite(currentlySelectedCard.tmemberCard.remaindTotalCount) }}次</span>
                        </div>
                        <div class="cardBalance-content">
                          <span>开卡日期:</span> <span>{{ currentlySelectedCard.tmemberCard.addDate &&
                            currentlySelectedCard.tmemberCard.addDate.split(" ")[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="currentlySelectedCard.tmemberCard.cardTypeCode === 2">
                    <div class="cardBalance">
                      <div class="kagin">
                        <div class="cardBalance-content">
                          <span>卡余额:</span> <span>{{ (Number(currentlySelectedCard.tmemberCard.initAmount) +
                            Number(currentlySelectedCard.tmemberCard.givenAmount)) | amountType }}</span> <span
                            @click="openTheRechargePage">充值</span>
                        </div>
                        <div class="kagin-content">
                          <span>本金:</span> <span>{{ currentlySelectedCard.tmemberCard.initAmount | amountType }}</span>
                          <span>赠金:</span> <span>{{ currentlySelectedCard.tmemberCard.givenAmount | amountType }}</span>
                        </div>
                        <div class="cardBalance-content">
                          <span></span> <span>{{ currentlySelectedCard.tmemberCard.addDate &&
                            currentlySelectedCard.tmemberCard.addDate.split(" ")[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="projectInclusion">
                  <div class="projectInclusion-item" v-for="(item, index) in currentlySelectedCard.cardDetail"
                    :key="index" @click.stop="lockingSeries(item.parentId, item.id, $event)"
                    @touchstart="handleTouchStart(item.parentId, item.id, $event)">
                    <el-tag size="mini" type="warning">{{ `${item.parentName ? item.parentName + "-" :
                      ""}${item.cardName.split("-")[1]
                      || item.cardName.split("-")[0]}-${item.cardCount}次` }}</el-tag>
                  </div>
                </div>

                <div class="availabilityPeriod">
                  <div class="cardRemarks" @click="openRemarksModification">
                    <span>卡备注：</span> <span style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{
                      currentlySelectedCard.tmemberCard.remark }}</span>
                  </div>
                  <div class="periodOfValidity">
                    <span>有效期：</span> <span>{{ currentlySelectedCard.tmemberCard.effectiveDays |
                      filterCalculationCardValidityPeriod
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <!--       订单数据         -->
      <div class="orderContent" :style="{ height: orderHeight + 'px' }">
        <!-- 没有加上的 -->
        <!-- <div class="searchHistory" v-show="!searchContent && !orderData.length">
                    <span class="historyTitle">搜索历史</span>
                    <span class="historyItem" v-for="item in searchHistoryList" :key="item.id">
                        <span>手机号码:&nbsp;&nbsp;{{ item.memberMobile  }}</span><span>{{item.memberName}}</span>
                    </span>
                </div> -->
        <template v-if="orderData.length">
          <div :class="currentProjectSubscript === index ? 'orderContent-item active' : 'orderContent-item'"
            v-for="(item, index) in orderData" :key="index">
            <div class="order-title">
              <span>
                <span> {{ item.packageName || item.productName }} </span> <i>{{ item.price | amountType }}</i>
              </span>
              <span> {{ item.packageTypeName || item.productTypeName }} </span>
              <!--         结算价         -->
              <span @click="modifiedSettlementPrice(item, index)">
                <!-- 最终价格 -->
                <b :style="item.isDiscount ? { color: 'green' } : { color: '#f64e60' }">{{ item.total | amountType }}
                </b> <i :style="item.isDiscount ? { color: 'green' } : { color: '#f64e60' }"
                  class="iconfont icon-bianji1"></i>
              </span>
            </div>
            <!--           右边 项目类型的显示            -->
            <template v-if="analyticalDataCommodity(item) === '0'">
              <div class="jobList" style="padding: 0px;" v-for="(subItem, subIndex) in item.handerNum" :key="subIndex"
                @click="openAddStaff(index, $event)">
                <div class="jobList_item" data-tag="openEmployeeViewport" :data-workType="analyticalWork(subItem)"
                  :class="{ 'highlight-job': highlightOrderIndex === index && highlightWorkType === analyticalWork(subItem) }">
                  <template v-if="analyzeWhetherThereAreJobs(analyticalWork(subItem), item.employeeList)">
                    <div class="jobList_item_data" style="margin: 0 5px" v-show="employeeItem.workTypeName === analyticalWork(subItem)"
                      v-for="(employeeItem, employeeIndex) in item.employeeList" :key="employeeIndex">
                      <div class="staff">
                        <!--                员工删除                -->
                        <span class="iconfont icon-shanchu"
                          @click.stop="projectDeletionEmployee(index, employeeItem.workTypeName)"></span>
                        <span>
                          <i>{{ employeeItem.employeeName }}</i> <i>{{ employeeItem.postName }}</i>
                        </span>
                      </div>
                      <template v-if="item.appointBrokerage === 0">
                        <div class="staffInfo" style="user-select: none; cursor: no-drop"><span
                            class="iconfont icon-bianji1" style="color: rgb(165 163 163);"></span> <span
                            style="color: rgb(165 163 163);">非指定</span></div>
                      </template>
                      <template v-else>
                        <div :class="employeeItem.appoint === 0 ? 'staffInfo' : 'staffInfo active'"
                          @click="modifyADesignation(item, employeeItem, index)">
                          <span class="iconfont icon-bianji1"></span> <span>{{ employeeItem.appoint === 0 ? "非指定" : "指定"
                          }}</span>
                        </div>
                      </template>
                      <template>
                        <div class="staffInfo" style="user-select: none; cursor: no-drop; margin-left: 25px;">
                          <span style="color: #1E90FF;">{{ analyticalWork(subItem) }}</span>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <span class="iconfont icon-tianjia" data-tag="openEmployeeViewport"
                      :data-workType="analyticalWork(subItem)"></span> <span data-tag="openEmployeeViewport"
                      :data-workType="analyticalWork(subItem)">添加{{ analyticalWork(subItem) }}</span>
                  </template>
                </div>
              </div>

              <div class="editingOperation">
                <div class="deleteItem" @click="deleteAnOrder(index)"><span class="iconfont icon-shanchu"></span>
                  <span>删除项目</span>
                </div>
              </div>
            </template>
            <!--           右边 产品类型的显示             -->
            <template v-else>
              <div class="employeeListContent" v-for="(subItem, subIndex) in item.employeeList" :key="subIndex">
                <div class="staff">
                  <!--                员工删除                -->
                  <span class="iconfont icon-shanchu" @click.stop="deletionOfEmployee(index, subIndex)"></span>
                  <span>
                    <i>{{ subItem.employeeName }}</i> <i>{{ subItem.postName }}</i>
                  </span>
                </div>

                <template v-if="item.appointBrokerage === 0">
                  <div class="staffInfo" style="user-select: none; cursor: no-drop"><span class="iconfont icon-bianji1"
                      style="color: rgb(165 163 163);"></span> <span style="color: rgb(165 163 163);">非指定</span></div>
                </template>
                <template v-else>
                  <div :class="subItem.appoint === 0 ? 'staffInfo' : 'staffInfo active'"
                    @click="modifyADesignation(item, subItem, index)">
                    <span class="iconfont icon-bianji1"></span> <span>{{ subItem.appoint === 0 ? "非指定" : "指定" }}</span>
                  </div>
                </template>

                <template>
                  <div class="staffInfo" style="user-select: none; cursor: no-drop; margin-left: 25px;">
                    <span style="color: #1E90FF;">销售{{ subIndex + 1 }}</span>
                  </div>
                </template>
              </div>
              <div class="addOnSales" @click="openAddStaff(index)" data-tag="openEmployeeViewport"
                v-show="item.employeeList.length < 5"><span class="iconfont icon-tianjia"
                  data-tag="openEmployeeViewport"></span>
                <span data-tag="openEmployeeViewport">添加销售</span>
              </div>
              <div class="order-add">
                <div class="deleteItem" @click="deleteAnOrder(index)"><span class="iconfont icon-shanchu"></span>
                  <span>删除产品</span>
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="icon-content"><span class="iconfont icon-dingdan"></span> <span>消费项目</span></div>
        </template>
      </div>
      <!--       结算订单     -->
      <div class="tallyOrder FixedBottom">
        <div class="totalPrices">
          <span>{{ amountInTotal | amountType }}</span>
        </div>
        <div class="pendingOrder" @click="pendingOrderList"><span>挂单</span></div>
        <div class="settleAccounts" @click="closeAnAccount"><span>结账</span></div>
      </div>
    </div>

    <!--   挂单手牌号  -->
    <el-dialog title="选择手牌号" :visible.sync="theHandNumberPopsUp" custom-class="handNumberScreeningClose"
      :before-close="closeTheHandNumber" width="70%">
      <div class="handNumberScreening">
        <span :class="returnStyleDisplay(item.hand) ? 'active' : ''" v-for="item in defaultHandNumber" :key="item.hand"
          @click="selectTheHandNumber(item.hand)"> #{{ item.hand }} </span>
      </div>
      <div class="manualInput">
        <span>手动输入手牌号</span>
        <span> <input type="text" maxlength="3" placeholder="请输入手牌号" v-model.trim="customizeTheHandNumber"
            @focus="noDisplay" @blur="permittedDisplay" oninput="value=value.replace(/[^0-9.]/g,'')" /> <i
            @click.stop="selectTheHandNumber(customizeTheHandNumber)">确定</i> </span>
      </div>
    </el-dialog>
    <!--   更新卡备注  -->
    <el-dialog title="修改卡备注" :visible.sync="cardRemarks" align="center" custom-class="userDefinedModifiedCardRemarks"
      width="500px">
      <div class="updateCardRemarks"><textarea v-model="cardNoteContent" ref="remark" placeholder="请输入卡备注信息" rows="4"
          cols="25" @focus="noDisplay" @blur="permittedDisplay"></textarea></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cardRemarks = false">取 消</el-button>
        <el-button type="primary" @click="updateCardRemarks">确 定</el-button>
      </span>
    </el-dialog>
    <!--   输入设备    -->
    <div class="inputEquipment" v-if="inputEquipmentShow" data-tag="setProjectFocusClose">
      <div class="clickContent" data-tag="setProjectFocus">
        <div class="inputTitle" data-tag="setProjectFocus">
          <span data-tag="setProjectFocus">修改价格</span>
          <span data-tag="setProjectFocus">（原价：<i data-tag="setProjectFocus">{{ setProjectPrice.originalProjectPrice |
            amountType }}</i>）</span>
        </div>
        <div class="priceTitle"><span>原价</span> <span>折扣</span> <span>结算价</span></div>
        <div class="priceInput" data-tag="setProjectFocus" ref="setProjectRef">
          <input :class="this.setProjectRefIndex === 0 ? 'active' : ''" data-tag="setProjectFocus" type="text"
            data-setProjectIndex="0" @focus="setProjectPriceFocus" @blur="permittedDisplay"
            @keydown="setProjectPriceKeydow" onfocus="this.select()" data-type="modifiedOriginalPrice" readonly
            v-model="setProjectPrice.modifiedOriginalPrice" />
          <input :class="this.setProjectRefIndex === 1 ? 'active' : ''" data-tag="setProjectFocus" type="text"
            data-setProjectIndex="1" @focus="setProjectPriceFocus" @blur="permittedDisplay"
            @keydown="setProjectPriceKeydow" onfocus="this.select()" data-type="modifiedDiscount" readonly
            v-model="setProjectPrice.modifiedDiscount" />
          <input :class="this.setProjectRefIndex === 2 ? 'active' : ''" data-tag="setProjectFocus" ref="costFocusRef"
            type="text" data-setProjectIndex="2" @focus="setProjectPriceFocus" @blur="permittedDisplay"
            @keydown="setProjectPriceKeydow" onfocus="this.select()" data-type="modifiedPrice" readonly
            v-model="modifiedPrice" />
        </div>

        <div class="inputContent" @click="modifyThePriceInputDevice">
          <span data-number="1" data-tag="setProjectFocus"><i data-number="1" data-tag="setProjectFocus">1</i></span>
          <span data-number="2" data-tag="setProjectFocus"><i data-number="2" data-tag="setProjectFocus">2</i></span>
          <span data-number="3" data-tag="setProjectFocus"><i data-number="3" data-tag="setProjectFocus">3</i></span>
          <span data-number="rollback" data-tag="setProjectFocus"><i data-number="rollback" data-tag="setProjectFocus"
              class="iconfont icon-zuojiantou"></i></span>
          <span data-number="4" data-tag="setProjectFocus"><i data-number="4" data-tag="setProjectFocus">4</i></span>
          <span data-number="5" data-tag="setProjectFocus"><i data-number="5" data-tag="setProjectFocus">5</i></span>
          <span data-number="6" data-tag="setProjectFocus"><i data-number="6" data-tag="setProjectFocus">6</i></span>
          <span data-number="clear" data-tag="setProjectFocus"><i data-number="clear" data-tag="setProjectFocus"
              class="iconfont icon-chacha"></i></span>
          <span data-number="7" data-tag="setProjectFocus"><i data-number="7" data-tag="setProjectFocus">7</i></span>
          <span data-number="8" data-tag="setProjectFocus"><i data-number="8" data-tag="setProjectFocus">8</i></span>
          <span data-number="9" data-tag="setProjectFocus"><i data-number="9" data-tag="setProjectFocus">9</i></span>
          <span data-number="return" data-tag="setProjectFocus"><i data-number="return" data-tag="setProjectFocus"
              class="iconfont icon-duihao"></i></span>
          <span data-number="none" data-tag="setProjectFocus" style="visibility: hidden"><i data-number="none"
              data-tag="setProjectFocus"></i></span> <span data-number="0" data-tag="setProjectFocus"><i data-number="0"
              data-tag="setProjectFocus">0</i></span>
          <span data-number="." data-tag="setProjectFocus"><i data-number="." data-tag="setProjectFocus">.</i></span>
          <span data-number="none" data-tag="setProjectFocus" style="visibility: hidden"><i data-number="none"
              data-tag="setProjectFocus"></i></span>
        </div>

        <div class="operatingButton" data-tag="setProjectFocus"><span data-tag="setProjectFocus"
            @click="setProjectFocusClose">取消</span> <span data-tag="setProjectFocus"
            @click="modifyTheOrderSettlementPrice"
            :class="!whetherTheSettlementPriceCanBeModified ? 'active' : ''">确认</span></div>
      </div>
    </div>
    <!--   数据修改    -->
    <dataModificationElement :show="modifyData" ref="integral" @noDisplay="noDisplay"
      @permittedDisplay="permittedDisplay" :title="modifyType === 'add' ? '增加积分' : '扣除积分'" @setIntegral="setIntegral"
      @closeMode="modifyData = $event">
    </dataModificationElement>

    <el-dialog title="打卡" :visible.sync="punchTheWindow" width="500px" @close="turnOffTimer">
      <div class="punchQRCode">
        <div class="currentDate">
          <span class="time_box">
            <span>{{ currentTime.time }}</span><i>:</i> <span>{{ currentTime.minute }}</span><i>:</i> <span>{{
              currentTime.second }}</span>
          </span>

          <span class="month">
            <span>{{ `${currentTime.month}月${currentTime.day}日` }}</span> <span>{{ currentTime.week }}</span>
          </span>
        </div>
        <div class="qrCode">
          <div class="twoDimensionalCodeDisplay"><img :src="wechatAddress" alt="" /></div>
          <div class="hint">
            <span class="icon"> <span class="iconfont icon-weixin"></span> <span>微信扫码</span> </span>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="punchTheWindow = false">取 消</el-button>
        <el-button type="primary" @click="punchTheWindow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

  <script>
  import moment from 'moment'
  import orderPending from './components/orderPending.vue'
  import dataModificationElement from './components/dataModificationElement/index.vue'
  import { Loading } from 'element-ui'
  import paperlessPublic from './mixins/paperlessPublic'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { deduplicate } from '../../utility_class/my_kit'

  // 防抖函数
  function debounce(func, wait) {
    let timeout = null
    return function () {
      const context = this
      const args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
  export default {
    name: 'paperless',
    data() {
      return {
        // 自定义手牌号
        customizeTheHandNumber: '',
        // 切换带图项目列表
        isPic: false,
        // 项目分类
        selectionBar: [
          {
            name: '项目消费',
            id: 0
          },
          {
            name: '产品消费',
            id: 1
          }
        ],
        // 操作类型
        operationType: [
          {
            name: '挂单',
            id: 1,
            icon: 'icon-31dingdan'
          },
          {
            name: '开卡',
            id: 4,
            icon: 'icon-huiyuanqia'
          },
          {
            name: '轮牌',
            id: 5,
            icon: 'icon-qiapai'
          }
        ],
        // 默认手牌号
        defaultHandNumber: [
          { hand: '001' },
          { hand: '002' },
          { hand: '003' },
          { hand: '004' },
          { hand: '005' },
          { hand: '006' },
          { hand: '007' },
          { hand: '008' },
          { hand: '009' },
          { hand: '010' },
          { hand: '011' },
          { hand: '012' },
          { hand: '013' },
          { hand: '014' },
          { hand: '015' },
          { hand: '016' },
          { hand: '017' },
          { hand: '018' },
          { hand: '019' },
          { hand: '020' }
        ],
        allProjectList: [], // 所有项目
        projectTypeList: [], // 项目类型
        projectList: [], // 项目
        currentProject: [], // 当前项目
        employeeList: [], // 员工数据
        currentEmployeeList: [], // 当前员工数据
        employeeNumber: '', // 员工号
        filterType: JSON.parse(window.localStorage.getItem('tenant')).isProductPriority === 0 ? 0 : 1, // 项目类型筛选
        projectType: 0, // 项目类型
        alphabeticScreening: [], // 项目首字
        letter: '', // 当前快捷筛选
        orderData: [], // 订单数据
        currentOrderData: [], // 当前订单数据
        searchContent: '', // 搜索框内容
        currentProjectSubscript: 0, // 当前选择的项目下标
        typeOfEmployeePosition: '', // 当前员工职位类型
        drawer: false,
        drawerType: 0,
        memberList: [], // 会员数据
        cardShowIndex: 0, // 记录上一次打开的下标
        currentSelectedMember: {
          memberName: '', // 会员姓名
          memberMobile: '', // 会员手机号
          memberNo: '', // 会员编号
          wechatAccount: '', // 微信号
          memberLevelName: '粉丝会员', // 会员等级
          memberSourceName: '手工录入', // 来源
          birthday: '', // 生日
          gender: 0, // 性别
          deductionsState: 1, // 是否启动会员交易设置
          remark: '', // 会员备注
          memberLevelId: '', // 会员等级id
          lockGrade: 0, // 会员锁定等级
          tenantId: window.localStorage.getItem('tenantId') // 门店id
        }, // 当前选择的会员
        orderHeight: '', // 订单高度
        currentlySelectedCard: null, // 当前所选卡
        inputEquipmentShow: false, // 控制修改结算价输入弹窗
        setProjectPrice: {
          modifiedOriginalPrice: 0, // 修改原价
          modifiedDiscount: 10, // 修改折扣
          originalProjectPrice: 0, // 项目原始价格
          setProjectIndex: 0 // 修改的项目下标
        },
        modifiedPrice: 0, // 修改结算价
        setProjectRefIndex: 2, // 结算价输入框下标
        orderTypes: 40, // 订单类型
        theHandNumberPopsUp: false, // 手牌号选择
        occupied: [], // 已占用手牌号
        orderDataHasBeenPosted: [], // 已挂单数据
        orderDataNumber: 0, // 挂单单数
        flag: false, // 当前是否是全屏状态
        cardRemarks: false, // 卡备注
        cardNoteContent: '', // 卡内容
        isSelectStatus: false, // 当前是否是全选状态
        antiShakeTimer: null, // 搜索防抖
        recordOrNot: '', // 是否正在录单
        handBrand: '', // 手牌号
        modifyData: false, // 是否可修改会员积分
        modifyType: '', // 修改或者减少积分
        currentStoreGlobalSettings: null, // 当前店铺全局设置
        theProjectSelectsGlobalListening: '', // 指定当前所选择的项目
        whetherTheSettlementPriceCanBeModified: false, // 是否可进行修改结算价
        searchInputBoxShow: false, // 项目查询显示与消失
        queryItem: '', // 项目查询标识
        punchTheWindow: false, // 打卡窗口
        // 日期显示
        currentTime: {
          time: '00',
          minute: '00',
          second: '00',
          month: '00',
          day: '00',
          week: '00'
        },
        // 微信打卡二维码
        wechatAddress: '',
        memberWhenPickingUpAnOrder: '', // 取单的时候有会员信息的标识，接口要给结算价了
        orderPrice: [],
        DepartmentalPerformance: [],
        isDepartmentalPerformance: [],
        departmentPerformanceList: null, // 部门业绩显示列表
        lastTouchTime: 0, // 上次触摸时间
        doubleTapDelay: 250, // 触摸的延迟时间
        isProcessingDoubleTap: false, // 新增：防止重复处理标志
        tapTimer: null,
        isProcessingTap: false, // 是否正在处理点击（防止重复触发）
        tapCount: 0,
        currentTapIndex: null,
        highlightWorkType: null,   // 当前高亮的工种
        highlightOrderIndex: -1,  // 高亮所属订单项索引
      }
    },
    beforeDestroy() {
      this.turnOffTimer()
    },

    // 过滤器
    filters: {
      // 过滤会员名称
      filterMemberName({ memberName, nickName }) {
        let name = ''
        memberName && (name += memberName)
        nickName && (memberName ? (name += `--${nickName}`) : (name += nickName))
        return name
      },
      // 计算卡有效期
      filterCalculationCardValidityPeriod(numberOfDays) {
        if (numberOfDays >= 9999) return '无限期'
        else return numberOfDays + '天'
      },
      // 金钱计算
      amountType(amount) {
        amount || (amount = 0)
        return '￥' + parseFloat(amount).toFixed(2)
      }
    },
    mixins: [paperlessPublic],
    // 数据监听
    watch: {
      // 监听会员数据变化
      memberList: {
        deep: true,
        handler(newValue) {
          if (newValue.length > 0) {
            this.$refs.memberEmployeeRef.style.transform = 'translateX(0px)'
            this.$refs.memberBoxRef.style.zIndex = '999'
          } else {
            this.$refs.memberEmployeeRef.style.transform = 'translateX(650px)'
            this.$refs.memberBoxRef.style.zIndex = '-999'
          }
          // 异步更新样式
          setTimeout(() => {
            this.stylesAreHighlyAdaptive() // 样式更新
          }, 100)
        }
      },
      // 监听手动修改结算价
      setProjectPrice: {
        deep: true,
        handler(newValue) {
          let { modifiedOriginalPrice, modifiedDiscount } = newValue
          const whetherToActivateTheRadiantFive = JSON.parse(window.localStorage.getItem('tenant')).roundOffState !== 0
          let aggregate = 0
          if (whetherToActivateTheRadiantFive) aggregate = Math.round((modifiedOriginalPrice * (modifiedDiscount / 10)).toFixed(2)).toString()
          else aggregate = (modifiedOriginalPrice * (modifiedDiscount / 10)).toFixed(2).toString()

          if (aggregate.split('.')[1]) aggregate = aggregate.split('.')[1] === '00' ? aggregate.split('.')[0] : `${aggregate.split('.')[0]}.${aggregate.split('.')[1]}`

          console.log('是否开启了四舍五入', whetherToActivateTheRadiantFive)
          this.modifiedPrice = aggregate
        }
      },
      // 监听结算价格变化
      modifiedPrice: {
        handler(newValue) {
          // this.whetherTheSettlementPriceCanBeModified = true
        }
      }
      // searchHistoryList(val) {
      //     if (val.length >5) {
      //         this.deleteSearchHistory(5)
      //     }
      // },
    },
    // 自定义指令
    directives: {
      // 关键字高光显示
      highlight: {
        bind(el, binding, vnode) {
          let _this = vnode.context
          let htmlText = binding.value || ''
          let start = htmlText.indexOf(_this.searchContent)
          if (!htmlText || start === -1) return
          let highlightKeywords = htmlText.substring(start, start + _this.searchContent.length)
          let earlyPart = htmlText.substring(0, start)
          let theLatterPart = htmlText.substring(start + _this.searchContent.length, htmlText.length)
          let nodes = `${earlyPart}<span style="color: red; font-weight: bold;">${highlightKeywords}</span>${theLatterPart}`
          // console.log("需要更新的数据", nodes);
          el.innerHTML = nodes
        }
      }
    },
    // 计算属性
    computed: {
      ...mapState(['serverTime']),
      ...mapGetters(['searchHistoryList']),

      // 合计金额
      amountInTotal() {
        return this.orderData.reduce((previousValue, currentValue) => {
          return previousValue + currentValue.total
        }, 0)
      },
      isRemaindTotalCountInfinite() {
        return (num) => num >= 5000 ? '无限' : num
      }
    },
    // 组件祖册
    components: {
      orderPending, // 挂单
      dataModificationElement // 数据修改组件
    },
    // 初始化
    async created() {
      await this.updateTime()
      this.localServerTime = this.serverTime || JSON.parse(localStorage.getItem('serverTime'))

      this.getStoreEmployeeData() // 获取门店员工数据
      this.toggleItemType() // 初始化页面
      this.getTheStorePersonalitySubCardId() // 获取门店次卡id
      // 监听视口发生变化 更新dom
      window.addEventListener('resize', () => {
        var isFull = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
        if (!isFull) this.flag = false
        this.stylesAreHighlyAdaptive() // 更新节点样式
      })
      // 获取店铺全局设置
      this.API.paperless.getStoreGlobalSetting().then((res) => {
        this.currentStoreGlobalSettings = res.data.records
      })
      // 首页扫码枪监听
      this.scannerGunListening(this.monitorTrigger)
      // 首页项目2次回车去结算
      this.monitorCarriageReturnPayment(this.closeAnAccount)
      // 读取当前项目显示方式
      this.isPic = JSON.parse(window.localStorage.getItem('isPic')) || false
      // 获取部门业绩显示
      this.API.store.getTenentListData({}, this.$store.state.tenant.id).then((res) => {
        console.log('获取部门业显示', res)
        this.departmentPerformanceList = res.data.isOpenDepartment
      })
      // 获取部门业绩
      this.API.goods.getDepartmentalPerformance({}).then((res) => {
        this.DepartmentalPerformance = res.data
        if (!this.isFocusedAndBlurred) {
          for (let i = 0; i < this.DepartmentalPerformance.length; i++) {
            this.isDepartmentalPerformance.push({
              achievement: 0,
              departmentId: this.DepartmentalPerformance[i].departmentId,
              departmentName: this.DepartmentalPerformance[i].departmentName,
              unAchievement: this.DepartmentalPerformance[i].unAchievement
            })
          }
          this.isFocusedAndBlurred = true
        }
        if (res.data[res.data.length - 1].unAchievement > 0) {
          this.DepartmentInput = true
          let index = res.data.length - 1
          this.unassigned = res.data[index].unAchievement
          this.performance = res.data[index].unAchievement
        } else {
          this.DepartmentInput = false
          return res.data.map((item) => {
            return [(this.unassigned = item.achievement), (this.performance = item.achievement)]
          })
        }
      })
    },
    mounted() {
      this.stylesAreHighlyAdaptive() // 结构更新
      this.getThePendingOrderNumber() // 获取挂单数据
      this.updatePermissionData() // 获取权限数据
    },
    methods: {
      updateHighlightForCurrentOrder(orderIndex) {
        const index = orderIndex !== undefined ? orderIndex : this.currentProjectSubscript
        if (index < 0 || index >= this.orderData.length) return
        const order = this.orderData[index]
        if (this.analyticalDataCommodity(order) === '0') {
          const filledWorkTypes = order.employeeList.map(e => e.workTypeName)
          const workTypeOrder = ['大工', '中工', '小工']
          const nextWorkType = workTypeOrder.find(wt => !filledWorkTypes.includes(wt))
          if (nextWorkType) {
            this.highlightWorkType = nextWorkType
            this.highlightOrderIndex = index
          } else {
            this.clearEmployeeHighlight()
          }
        } else {
          this.clearEmployeeHighlight()
        }
      },
      closeEmployeeViewport() {
        this.$refs.employeeRef.style.transform = 'translateX(510px)'
        this.clearEmployeeHighlight()
      },
      clearEmployeeHighlight() {
        this.highlightWorkType = null
        this.highlightOrderIndex = -1
      },
      closeSearch() {
        this.searchInputBoxShow = false;
        this.queryItem = ''; // 清空输入框内容
        // 恢复项目列表到默认类型
        if (this.projectTypeList.length) {
          // 如果第一项是搜索时临时添加的“全部”，需要移除
          if (this.projectTypeList[0].dictName === '全部') {
            this.projectTypeList.splice(0, 1);
          }
          this.projectType = 0;
          this.switchItems(this.projectTypeList[0], 0);
        }
      },
      // 限制商品名称长度
      textLength(text) {
        if (text.length > 5) {
          return text.substring(0, 5) + '...'
        } else {
          return text
        }
      },

      ...mapMutations(['addSearchHistory', 'deleteSearchHistory']),
      // turnOffTimer() {
      //     console.log('关闭计时器')
      //     clearInterval(this.timer)
      // },
      // 操作
      operation({ id }) {
        // 开卡
        if (id === 4) {
          this.membershipCardOpening()
        }
        // 挂单
        if (id === 1) {
          this.getTheListOfOrderingData({ orderClear: false })
        }
        //  轮牌
        if (id === 5) {
          this.openTheStaffCard()
        }
      },
      // 打开员工轮牌
      openTheStaffCard() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: '加载中',
          background: 'rgba(0, 0, 0, .2)',
          spinner: 'el-icon-loading'
        })

        // 延迟400毫秒一下 稍微让页面加载一下 不然请求后计算速度太快加载刚出来就没了 就会一闪而过
        setTimeout(() => {
          this.$nextTick(() => {
            loadingInstance.close() // 关闭加载效果
            this.theHandNumberPopsUp = false // 关闭手牌号筛选框
            this.drawerType = 5
            this.drawer = true
          })
        }, 400)
      },
      // 重置会员名
      resetMemberName({ memberName, nickName }) {
        let name = ''
        memberName && (name += memberName)
        nickName && (memberName ? (name += `--${nickName}`) : (name += nickName))
        return name
      },
      // 分析当前数据列表中是否有对应工种
      analyzeWhetherThereAreJobs(workType, employeeList) {
        // console.log("分析数据", workType, employeeList);
        return employeeList.some((item) => item.workTypeName === workType)
      },
      // 失去焦点业绩
      outOfFocusPerformance() {
        this.setProjectPrice.modifiedDiscount = this.reverseDiscountSettlementPrice(this.setProjectPrice.modifiedOriginalPrice, this.modifiedPrice)
      },
      // 分析工种
      analyticalWork(index) {
        return index === 1 ? '大工' : index === 2 ? '中工' : index === 3 ? '小工' : ''
      },
      // 四舍五入
      roundFixed(num, fixed) {
        // 修改js四舍五入
        let pos = num.toString().indexOf('.')
        let decimal_places = num.toString().length - pos - 1
        let _int = num * Math.pow(10, decimal_places)
        let divisor_1 = Math.pow(10, decimal_places - fixed)
        let divisor_2 = Math.pow(10, fixed)
        return Math.round(_int / divisor_1) / divisor_2
      },
      // 切换项目类型 项目或者产品
      switchingType({ id }) {
        this.filterType = id // 修改项目类型
        this.typeOfEmployeePosition = id === 0 ? '大工' : '' // 切换默认值
        this.projectTypeList = []
        this.projectList = []
        this.toggleItemType() // 切换项目类型
      },
      // 切换项目类型
      toggleItemType() {
        this.projectType = 0 // 修改类型筛选条件为默认类型
        this.letter = '' // 清空字母筛选条件
        this.theProjectSelectsGlobalListening = '' // 清空锁定
        let project1 = null
        let project2 = null

        // 获取项目类型
        let projectTypeParams = {
          dict_type: this.filterType === 0 ? 'DT_007' : 'DT_008',
          asc: 'order_num'
        }
        project1 = this.API.paperless.getGoodDict(projectTypeParams)
        // 判断是获取项目还是获取产品
        let params = {
          query_type: 'like',
          on_sale_status: 0,
          pinyin: 0
        }
        if (this.filterType === 0) project2 = this.API.paperless.getGoodPackageList(params)
        else project2 = this.API.paperless.getTenantProductList(params)

        Promise.all([project1, project2]).then((res) => {
          // console.log(res);
          const [data1, data2] = res
          if (this.filterType === 1) data2.data.forEach((item) => (item.appointBrokerage = 0))
          this.projectTypeList = data1.data // 项目类型
          this.allProjectList = data2.data // 项目
          this.checkItemDataVolume(this.filterType === 0 ? 'packageTypeId' : 'productTypeId') // 检测是否有无项目类型
          this.screeningItem() // 筛选项目
        })
      },
      // 切换项目
      switchItems(item, index) {
        console.log('添加项目', item, index)
        this.projectType = index
        this.letter = '' // 字母筛选条件清空
        this.theProjectSelectsGlobalListening = '' // 清空锁定
        this.screeningItem() // 筛选项目
      },
      // 字母筛选条件
      switchingFilterCondition(item) {
        this.theProjectSelectsGlobalListening = '' // 清空锁定
        if (this.letter === item) this.letter = ''
        else this.letter = item // 存储当前选择字母

        // 更新项目列表
        this.$nextTick(() => {
          // 判断当前字母是否筛选了
          if (this.letter === '') this.projectList = this.currentProject
          else this.projectList = this.currentProject.filter((item) => item.pinyin === this.letter)
        })
      },
      // 筛选项目
      screeningItem() {
        if (!this.projectTypeList.length) return
        const { id } = this.projectTypeList[this.projectType] // 当前选择的项目类型
        // 判断当前是产品还是项目
        const projectType = this.filterType === 0 ? 'packageTypeId' : 'productTypeId'
        const projectName = this.filterType === 0 ? 'packageName' : 'productName'
        const projectCode = this.filterType === 0 ? 'packageCode' : 'productCode'

        // 过滤出当前所选的项目类型所对应的数据
        this.projectList = this.allProjectList.filter((item) => {
          // 存储首字母
          return item[projectType] === id
        })

        // 项目顺序排列
        for (let i = 0; i < this.projectList.length; i++) {
          for (let j = 0; j < this.projectList.length; j++) {
            if (parseFloat(this.projectList[i][projectCode]) < parseFloat(this.projectList[j][projectCode])) {
              let tmp = this.projectList[i]
              this.projectList[i] = this.projectList[j]
              this.projectList[j] = tmp
            }
          }
        }
        console.log('当前设置', this.projectList)
        this.currentProject = this.projectList // 存储当前项目
        this.filterLetter(projectName) // 筛选首字母
      },
      // 筛选字母
      filterLetter(projectName) {
        let alphabeticArray = this.projectList.map((item) => item.pinyin)
        let deWeight = []
        alphabeticArray.forEach((item) => {
          if (deWeight.indexOf(item) === -1) deWeight.push(item)
        })
        this.alphabeticScreening = deWeight
      },
      // 切换项目后检测是否有无用的
      checkItemDataVolume(projectName) {
        // 调整出产品或者项目id
        const projectIdList = this.allProjectList.map((item) => item[projectName])
        // 查看项目类型的id是否包含在里面
        this.projectTypeList = this.projectTypeList.filter((item) => projectIdList.indexOf(item.id) !== -1)
      },
      // 选择项目
      async option(item, orderType, index) {
        console.log('选择项目', item, orderType, index)
        const itemPrice = await this.calculateProjectPrice(item)
        this.$set(item, 'costPrice', itemPrice.costPrice) // 结算价
        this.$set(item, 'originPrice', itemPrice.originPrice) // 原价
        this.$set(item, 'total', itemPrice.total) // 合计价
        this.$set(item, 'isDiscount', itemPrice.isDiscount) // 是否折扣
        this.theProjectSelectsGlobalListening === index && (this.theProjectSelectsGlobalListening = '')
        if (orderType === 'merge') {
          console.log('数据push', { ...item })
          this.orderData.push({ ...item })
        } else {
          this.orderData.push({
            ...item,
            employeeList: [] // 员工数据
          })
          this.openAddStaff(this.orderData.length - 1) // 打开添加员工视口
        }
      },
      // 更新 upDrawer
      upDrawer() {
        this.drawer = !this.drawer
        this.drawerType = 0
        this.switchingType({
          id: JSON.parse(window.localStorage.getItem('tenant')).isProductPriority === 0 ? 0 : 1
        })
        // 开启首页扫码枪监听
        this.scannerGunListening(this.monitorTrigger)
        // 关闭需要挂起首页2次回车结算
        this.monitorCarriageReturnPayment(this.closeAnAccount)
      },
      memberSearchFocus() {
        this.queryItem = '禁止'
      },
      // 清除弹出视口样式
      clearViewport($event) {
        const { tag } = $event.target.dataset
        if (tag === 'employeeViewport' || tag === 'clear' || tag === 'memberViewport') return
        tag !== 'openEmployeeViewport' && (this.$refs.employeeRef.style.transform = 'translateX(520px)')

        // 关闭视口时 清除高亮
        if (tag !== 'openEmployeeViewport') this.clearEmployeeHighlight()
      },
      // 点击输入
      hitEnter($event) {
        const { number } = $event.target.dataset
        if (number === undefined) return
        if (number === 'rollback') {
          this.$nextTick((_) => {
            this.searchContent = this.searchContent.substring(this.searchContent.length - 1, 0)
            if (this.searchContent === '') this.memberList = []
            else this.searchMembership()
          })
          return
        }
        if (number === 'clear') {
          this.searchContent = ''
          this.memberList = []
          return
        }
        if (number === 'return') {
          if (!this.memberList.length) return this.$message.warning('无会员信息')
          this.selectMemberInformation(this.memberList[0])
          return
        }
        this.searchContent += number
        this.searchMembership()
      },
      // 删除订单
      deleteAnOrder(index) {
        this.orderData.splice(index, 1)
        this.fullOrderPriceRefresh() // 重新计算项目
      },
      // 获取门店员工数据
      getStoreEmployeeData() {
        return new Promise((resolve, reject) => {
          // 获取员工信息
          this.API.paperless.acquireExistingEmployeesOfTheStore().then((res) => {
            let staff = res.data
            let position = []
            let newPosition = []
            // 员工数据整理
            staff.forEach((item) => {
              this.$set(item, 'numberOfAdditions', 0)
              const positionIndex = position.indexOf(item.postId)
              if (positionIndex === -1) {
                position.push(item.postId)
                newPosition.push({
                  postName: item.postName,
                  postId: item.postId,
                  positionEmployee: [].concat([item])
                })
              } else newPosition[positionIndex].positionEmployee.push(item)
            })

            this.employeeList = this.deepCopy(newPosition) // 存储门店员工数据
            this.currentEmployeeList = this.deepCopy(newPosition) // 存储当前员工数据
            resolve()
          })
        })
      },
      // 员工搜索
      searchForEmployees() {
        let newEmployeeList = this.deepCopy(this.currentEmployeeList)
        newEmployeeList.forEach((item) => {
          let employee = []
          this.employeeNumber !== '' && (employee = item.positionEmployee.filter((subItem) => subItem.employeeNo === this.employeeNumber))
          this.employeeNumber === '' && (employee = item.positionEmployee.filter((subItem) => subItem))
          // 记录下标
          this.orderData[this.currentProjectSubscript].employeeList.forEach((subItem) => {
            employee.forEach((employeeItem) => {
              if (subItem.employeeNo === employeeItem.employeeNo) {
                this.$set(employeeItem, 'label', true)
              }
            })
          })
          item.positionEmployee = employee
        })

        this.$nextTick(() => {
          this.employeeList = newEmployeeList.filter((item) => item.positionEmployee.length)
          this.calculateEmployeeSelectionStatus() // 计算员工选择状况
        })
      },
      // 选择员工
      selectEmployees(item, $event) {
        this.$nextTick(async () => {
          // 判断员工是否添加上限
          if (this.orderData[this.currentProjectSubscript].employeeList.length >= this.orderData[this.currentProjectSubscript].handerNum) {
            return this.$message.warning('员工添加上限')
          }
          if (this.orderData[this.currentProjectSubscript].employeeList.length >= 5) return this.$message.warning('员工添加上限')

          this.$set(item, 'label', true) // 选择员工给员工添加员工标记
          this.$set(item, 'appoint', 0) // 给员工默认添加非指定
          this.$set(
            item,
            'workTypeName',
            (() => {
              let workType = ''
              let workTypeList = ['小工', '中工', '大工']
              let newWorkTypeList = []
              this.orderData[this.currentProjectSubscript].employeeList.forEach((employeeItem) => {
                employeeItem.workTypeName && newWorkTypeList.push(employeeItem.workTypeName)
              })
              if (newWorkTypeList.indexOf(this.typeOfEmployeePosition) === -1) return this.typeOfEmployeePosition
              workTypeList.forEach((employeeItem) => {
                if (newWorkTypeList.indexOf(employeeItem) === -1) workType = employeeItem
              })
              return workType
            })()
          )
          this.orderData[this.currentProjectSubscript].employeeList.push(this.deepCopy(item))

          // 计算员工业绩 添加员工判断是否修改了结算价
          console.log('当前项目信息', this.orderData[this.currentProjectSubscript])
          const { price, costPrice } = this.orderData[this.currentProjectSubscript]
          let isSettlementPriceModification = parseFloat(price) === parseFloat(costPrice)
          const { consumeOrderEmployeeBrokerageVOS } = await this.calculateProjectPrice(this.orderData[this.currentProjectSubscript], undefined, isSettlementPriceModification ? undefined : costPrice, false, false)
          console.log('业绩计算结果', consumeOrderEmployeeBrokerageVOS)
          this.orderData[this.currentProjectSubscript].employeeList.forEach((employeeItem) => {
            // console.log(employeeItem);
            consumeOrderEmployeeBrokerageVOS.forEach((subItem) => {
              if (subItem.employeeId === employeeItem.id && subItem.employeeNo === employeeItem.employeeNo && employeeItem.workTypeName === subItem.workType) {
                employeeItem.sell = subItem.sell || 0 // 销售业绩
                employeeItem.work = subItem.work || 0 // 劳动业绩
                employeeItem.appoint = subItem.appoint || 0 // 指定 非指定
                employeeItem.workType = subItem.workType // 劳动类型
              } else if (subItem.employeeId === employeeItem.id && subItem.employeeNo === employeeItem.employeeNo && this.analyticalDataCommodity(this.orderData[this.currentProjectSubscript]) === '1') {
                employeeItem.sell = subItem.sell || 0 // 销售业绩
                employeeItem.work = subItem.work || 0 // 劳动业绩
                employeeItem.appoint = subItem.appoint || 0 // 指定 非指定
                employeeItem.workType = subItem.workType // 劳动类型
              }
            })
          })

          // 计算员工选择状况
          this.calculateEmployeeSelectionStatus()
          this.updateHighlightForCurrentOrder()

          console.log('选择员工数据', this.orderData[this.currentProjectSubscript].employeeList.length)
          // 判断员工是否添加上限 如果添加上限后关闭员工选择窗口
          if (this.orderData[this.currentProjectSubscript].employeeList.length >= this.orderData[this.currentProjectSubscript].handerNum || this.orderData[this.currentProjectSubscript].employeeList.length >= 5) {
            this.$refs.employeeRef.style.transform = 'translateX(520px)'
            this.clearEmployeeHighlight()
          }
        })
      },
      // 计算员工选择状况
      calculateEmployeeSelectionStatus() {
        // 员工计数
        this.employeeList.forEach((subItem) => {
          subItem.positionEmployee.forEach((emp) => {
            emp.numberOfAdditions = 0
          })
        })
        this.orderData[this.currentProjectSubscript].employeeList.forEach((employeeItem) => {
          this.employeeList.forEach((subItem) => {
            subItem.positionEmployee.forEach((emp) => {
              if (employeeItem.employeeNo === emp.employeeNo) emp.numberOfAdditions = emp.numberOfAdditions + 1
            })
          })
        })
        this.employeeList.forEach((subItem) => {
          subItem.positionEmployee.forEach((emp) => {
            if (emp.numberOfAdditions) emp.label = true
            else emp.label = false
          })
        })
      },
      // 打开添加员工视口
      async openAddStaff(index, $event) {
        // 经手人数
        if (Number(this.orderData[index].handerNum) === 0) return
        const workType = $event ? $event.target.dataset.worktype : null
        // this.typeOfEmployeePosition = workType || (this.filterType === 0 ? '大工' : null) // 存储当前员工职位
        // 如果没有明确的点击工种，且当前高亮已指向本订单项，则沿用现有高亮
        if (!workType && this.highlightOrderIndex === index && this.highlightWorkType) {
          this.typeOfEmployeePosition = this.highlightWorkType
        } else {
          this.typeOfEmployeePosition = workType || (this.filterType === 0 ? '大工' : null)
        }

        // 最终同步高亮状态
        this.highlightWorkType = this.typeOfEmployeePosition
        this.highlightOrderIndex = index

        console.log(this.typeOfEmployeePosition)
        this.currentProjectSubscript = index // 存储当前选择的项目下标
        this.employeeNumber = '' // 清空搜索记录
        // console.log("打开员工列表", this.employeeList);
        await this.getStoreEmployeeData() // 更新员工数据
        this.employeeList = this.deepCopy(this.currentEmployeeList)
        // 初始化员工下标
        this.employeeList.forEach((item) => {
          item.positionEmployee.forEach((subItem) => {
            subItem.label = false
          })
        })

        // 获取当前项目中的员工信息，初始化已选员工
        this.orderData[this.currentProjectSubscript].employeeList.forEach((item) => {
          this.employeeList.forEach((subItem) => {
            subItem.positionEmployee.forEach((threeLevel) => {
              if (item.id === threeLevel.id) {
                this.$set(threeLevel, 'label', true)
              }
            })
          })
        })
        // 计算员工选择数量状态
        this.calculateEmployeeSelectionStatus()
        // 关闭搜索框
        this.openProjectQuery(false);
        this.$refs.employeeRef.style.transform = 'translateX(0px)'
      },
      // 员工选择栏移除员工
      removeAnEmployee(employeeNo) {
        let subIndex = ''
        this.orderData[this.currentProjectSubscript].employeeList.forEach((item, index) => {
          if (item.employeeNo === employeeNo) subIndex = index
        })
        // 删除员工
        this.deletionOfEmployee(this.currentProjectSubscript, subIndex)
        // 计算员工选择数量状态
        this.calculateEmployeeSelectionStatus()
      },
      // 删除员工
      deletionOfEmployee(index, subIndex) {
        this.orderData[index].employeeList.splice(subIndex, 1)
        // 框打开时刷新选择框，未打开则打开
        if (this.$refs.employeeRef.style.transform === 'translateX(0px)') {
          this.openAddStaff(index)
        }
        // 更新高亮
        this.updateHighlightForCurrentOrder(index)
        this.$forceUpdate()
      },
      // 项目删除员工
      projectDeletionEmployee(index, workType) {
        this.orderData[index].employeeList = this.orderData[index].employeeList.filter(
          (item) => item.workTypeName !== workType
        )
        this.updateHighlightForCurrentOrder(index)
        this.openAddStaff(index)   // 刷新选择框
        this.$forceUpdate()
      },
      // 获取会员信息
      searchMembership: debounce(async function () {
        this.openProjectQuery(false)
        // 判断输入框是否为空
        if (this.searchContent === '') {
          return this.$nextTick((_) => {
            this.memberList = []
          })
        }
        // 获取会员信息
        let params = {
          query: this.searchContent
        }
        const { data } = await this.API.paperless.getMemberInfoList(params)
        this.memberList = [] // 数据清空

        data.forEach((item) => {
          this.$set(item, 'cardShow', false) // 添加卡详情展开收起控件
          this.$set(item, 'currentMembershipCardList', null) // 当前卡列表
        })
        this.$nextTick((_) => {
          this.memberList = data.length > 0 ? data : []
        })
      }, 300),
      // 展开卡详情
      async expansionCardDetails(item, index) {
        // 判断当前所点击的下标是否与上一次的相同
        if (this.cardShowIndex === index) item.cardShow = !item.cardShow
        else {
          this.memberList[this.cardShowIndex].cardShow = false
          item.cardShow = true
          this.cardShowIndex = index
        }

        // 发送请求获取卡信息
        let param = {
          phone: item.memberMobile,
          cardLeachStatus: '1'
        }
        const { code, data, data2 } = await this.API.paperless.getMemberParticulars(param)
        // 调用 vuex 设置 会员搜索历史
        if (data2.id) {
          this.addSearchHistory(data2)
        }

        if (code === 0 && data.length) {
          // 进行开列表排序
          let refillCard = data.filter((item) => item.tmemberCard.cardTypeCode === 2) // 充值卡
          let personalitySubcard = data.filter((item) => item.tmemberCard.cardTypeCode === 3) // 个性次卡
          let discountCard = data.filter((item) => item.tmemberCard.cardTypeCode === 1) // 折扣卡
          let subcard = data.filter((item) => item.tmemberCard.cardTypeCode === 0) // 次卡
          item.currentMembershipCardList = [...refillCard, ...subcard, ...discountCard, ...personalitySubcard]
        }
      },
      // 样式高度自适应
      stylesAreHighlyAdaptive() {
        this.$nextTick(() => {
          let clientHeight = 0
          let clientHeightRight = 0
          this.$refs.memberInformationRef && (clientHeight = this.$refs.memberInformationRef.clientHeight)
          this.$refs.paperlessRightRef && (clientHeightRight = this.$refs.paperlessRightRef.clientHeight)
          this.orderHeight = `${clientHeightRight - clientHeight - 43}`
        })
      },
      // 选择了会员信息

      async selectMemberInformation(member, cardItem, cardId) {
        console.log('会员信息', member, cardItem, cardId)
        // 判断当前会员是否有卡列表 在判断是否有传递卡项
        if (!member.currentMembershipCardList || !cardItem) {
          let param = {
            phone: member.memberMobile,
            cardLeachStatus: '1'
          }
          // 获取会员卡列表
          const { code, data, data2 } = await this.API.paperless.getMemberParticulars(param)
          console.log('会员卡', data)
          member = data2 // 同步会员信息
          // 调用 vudx 设置会员搜索历史
          if (data2) {
            this.addSearchHistory(data2)
          }
          // this.searchHistoryList.unshift(data2)
          // this.searchHistoryList=deduplicate(this.searchHistoryList,'id')
          // localStorage.setItem('searchHistoryList',JSON.stringify(this.searchHistoryList))
          console.log('同步会员数据', member, data2)
          if (code === 0 && data.length !== 0) {
            // 进行开列表排序
            let refillCard = data.filter((item) => item.tmemberCard.cardTypeCode === 2) // 充值卡
            let personalitySubcard = data.filter((item) => item.tmemberCard.cardTypeCode === 3) // 次卡
            let discountCard = data.filter((item) => item.tmemberCard.cardTypeCode === 1) // 折扣卡
            let subcard = data.filter((item) => item.tmemberCard.cardTypeCode === 0) // 次卡
            member.currentMembershipCardList = [...refillCard, ...subcard, ...personalitySubcard, ...discountCard, ]
            // 判断是否传递了卡 如果传递了则表示用户选择了会员卡 如果没有传递则表示需要选择卡列表的第一张卡做为卡id
            if (member.currentMembershipCardList.length && !cardItem) cardItem = member.currentMembershipCardList[0]
          }
          // 判断是否传递卡id 如果传递卡id说明获取了会员并且锁定所传递的卡项
          if (cardId) {
            member.currentMembershipCardList.forEach((item) => {
              if (item.tmemberCard.id === cardId) cardItem = item
            })
          }
        }
        // 先更新数据等数据更新完成在更新dom节点
        this.currentSelectedMember = member // 存储当前会员信息
        this.currentlySelectedCard = cardItem // 存储当前所选所选卡
        this.fullOrderPriceRefresh() // 全订单业绩价格刷新
        this.stylesAreHighlyAdaptive() // 刷新页面节点样式
      },
      // 重置搜索数据
      research(isoriginalPriceOrNot) {
        // isoriginalPriceOrNot  这个参数只有点头像取消会员卡的时候传递  这就是一坨大便需求拉出来的
        // whetherToRefreshOrderPerformance 是否要调用订单技术从新结算 没啥作用这里
        this.currentSelectedMember = {
          memberName: '', // 会员姓名
          memberMobile: '', // 会员手机号
          memberNo: '', // 会员编号
          wechatAccount: '', // 微信号
          memberLevelName: '粉丝会员', // 会员等级
          memberSourceName: '手工录入', // 来源
          birthday: '', // 生日
          gender: 2, // 性别
          deductionsState: 1, // 是否启动会员交易设置
          remark: '', // 会员备注
          memberLevelId: '', // 会员等级id
          lockGrade: 0, // 会员锁定等级
          tenantId: window.localStorage.getItem('tenantId') // 门店id
        } // 会员清空
        this.currentlySelectedCard = null // 当前所选卡项
        this.searchContent = '' // 搜索内容
        this.memberList = [] // 清空会员信息
        this.fullOrderPriceRefresh(isoriginalPriceOrNot) // 全订单业绩价格刷新
        this.stylesAreHighlyAdaptive() // 更新节点样式
        this.theProjectSelectsGlobalListening = '' // 清空锁定
      },
      // 选择会员卡
      selectMembershipCard(cardItem) {
        this.currentlySelectedCard = cardItem
        console.log('当前会员卡的信息', this.currentlySelectedCard)
        this.fullOrderPriceRefresh() // 全订单业绩价格刷新
      },
      // 修改指定
      async modifyADesignation(projectItem, employeeItem) {
        employeeItem.appoint = employeeItem.appoint === 0 ? 1 : 0
        // 重新计算当前员工业绩 计算当前是否修改过结算价格
        const { price, costPrice } = projectItem
        let isSettlementPriceModification = parseFloat(price) === parseFloat(costPrice)
        const { consumeOrderEmployeeBrokerageVOS } = await this.calculateProjectPrice(projectItem, false, isSettlementPriceModification ? undefined : costPrice, false, false)
        consumeOrderEmployeeBrokerageVOS.forEach((item) => {
          if (employeeItem.id === item.employeeId && employeeItem.employeeNo === item.employeeNo && employeeItem.workTypeName === item.workType) {
            employeeItem.sell = item.sell || 0 // 销售业绩
            employeeItem.work = item.work || 0 // 劳动业绩
            employeeItem.appoint = item.appoint || 0 // 指定 非指定
            employeeItem.workType = item.workType // 劳动类型
          }
        })
      },
      /**
       * @description: 项目和产品计算价格
       * @param {object} project 参数
       * @param {Boolean} isRound 是否四舍五入
       * @param {string} settlementPrice 修改结算价
       * @param {string} deleteFlag 是否删除项目
       * @param {string} isItemNumAdd 是否增加次卡项目数量
       * @return {object} 计算完成结果
       */
      calculateProjectPrice(project, isRound = true, settlementPrice = '', deleteFlag = false, isItemNumAdd = true) {
        console.log(settlementPrice, project.packageName + '改变之后的价格')
        console.log(project, 'project111')
        // project 项目 isRound 是否四舍五入 settlementPrice 修改结算价
        // console.log('订单结算接口接受的参数project',project);
        return new Promise(async (resolve, reject) => {
          const { id, packageName } = project // 当前选择项目
          let projectOrNot = packageName ? 0 : 1 // 0项目 1产品
          // 获取卡详情
          let tmemberCard = null
          let cardDetail = null
          if (this.currentlySelectedCard) {
            tmemberCard = this.currentlySelectedCard.tmemberCard
            cardDetail = this.currentlySelectedCard.cardDetail
          }
          let oldNum = 0
          let type = projectOrNot === 0 ? 'package' : 'product' // 类型名称
          // 判断当前所选卡项是否是个性次卡 如果是个性次卡则进行相同项目数获取
          if (tmemberCard && (tmemberCard.cardTypeCode === 3 || (tmemberCard.cardTypeCode === 0 && tmemberCard.totalCount < 9999))) {
            let isSubitems = cardDetail.every((item) => item.cardName.split('-').length > 1)
            const totalCount = tmemberCard.remaindTotalCount // 项目次卡
            // 判断当前项目在订单列表中存在几个 如果当前卡项包含所有项目则直接取消判断项目是否包含在卡里
            console.log('订单列表-----接口', this.orderData)
            let currentCardCount = this.orderData.reduce((previousValue, currentValue) => {
              if (isSubitems) {
                // 子项目处理
                if (currentValue.id === id) return ++previousValue
                else return previousValue
              } else {
                // 父级项目处理
                if (currentValue[`${type}TypeId`] === project[`${type}TypeId`] || cardDetail[0].cardName === '项目') return ++previousValue
                else return previousValue
              }
            }, 0)

            if (isSubitems) {
              cardDetail.forEach((item) => {
                const { cardCount, cardName } = item
                const newCardName = cardName.split('-').length > 1 ? cardName.split('-')[1] : cardName.split('-')[0]
                if (project[`${type}Name`] === newCardName) {
                  currentCardCount = currentCardCount + 1 > cardCount ? totalCount : currentCardCount
                }
              })
            }

            if (!isSubitems) {
              cardDetail.forEach((item) => {
                const { cardCount, cardName } = item
                const newCardName = cardName.split('-').length > 1 ? cardName.split('-')[1] : cardName.split('-')[0]
                if (project[`${type}TypeName`] === newCardName) {
                  currentCardCount = currentCardCount + 1 > cardCount ? totalCount : currentCardCount
                }
              })
            }

            // 判断当前项目是否包含在个性次卡内 如果包含在卡内需要根据项目数据去计算是否还可进行耗卡
            cardDetail.forEach((item) => {
              const { cardName } = item
              const newCardName = cardName.split('-').length > 1 ? cardName.split('-')[1] : cardName.split('-')[0]
              // 如果当前所选项目属于个性次卡所包含的项目则执行
              console.log('项目判断', newCardName)
              if (newCardName === project[`${type}TypeName`] || newCardName === project[`${type}Name`] || newCardName === '项目') {
                oldNum = currentCardCount >= Number(totalCount) ? Number(totalCount) : currentCardCount
              }
            })
          }

          // console.log("当前旧项目数", oldNum);
          // console.log(this.currentlySelectedCard);
          let params = null // 请求体
          // 会员消费 或 散客消费
          if (this.currentlySelectedCard) {
            console.log('会员消费', settlementPrice)
            let itemNum = 0
            if (this.currentlySelectedCard.tmemberCard.cardTypeName == '次卡') {
              if (!deleteFlag) {
                const packageData = {
                  isDiscount: false,
                  oldNum: -1,
                  num: 0,
                  oldPackageId: '',
                  newPackageId: project.id,
                  memberCardId: this.currentlySelectedCard.tmemberCard.id
                }

                const { data } = await this.API.order.getPackageNew(packageData)
                let packType = 0 // 0 不耗卡 1 项目耗卡 2 项目类别耗卡
                if (!data.flag && data.discount) {
                  packType = 1
                  project._isDiscount = true
                  if (isItemNumAdd) {
                    itemNum++
                  }
                }

                if (data.flag && data.discount) {
                  project._classTypeId = data.classType
                  project._isDiscount = true
                  packType = 2
                  if (isItemNumAdd) {
                    itemNum++
                  }
                }

                if (isItemNumAdd) {
                  for (let i = 0; i < this.orderData.length; i++) {
                    if (packType === 0) break;

                    if (packType === 1 && data.packageId == this.orderData[i].id && this.orderData[i]._isDiscount) {
                      this.orderData[i]._itemIndex = itemNum
                      itemNum++
                      continue;
                    }
                    if (packType === 2 && data.classType == this.orderData[i]._classTypeId && this.orderData[i]._isDiscount) {
                      this.orderData[i]._itemIndex = itemNum
                      itemNum++
                    }
                  }
                  project._itemIndex = itemNum
                } else {
                  itemNum = project._itemIndex || 0
                }
              } else {
                itemNum = project._itemIndex || 0
              }
            }
            params = {
              memberCardId: this.currentlySelectedCard.tmemberCard.id,
              itemId: id,
              num: 1,
              itemType: projectOrNot,
              manualOperation: isRound ? '0' : '1',
              employeeAppointDTOList: [],
              originPrice: project.price,
              costPrice: settlementPrice,
              oldNum: itemNum,
              // oldNum: 0
            }
          } else {
            console.log('散客消费', settlementPrice)
            params = {
              itemId: id,
              num: 1,
              itemType: projectOrNot,
              manualOperation: isRound ? '0' : '1',
              employeeAppointDTOList: [],
              originPrice: project.price,
              costPrice: settlementPrice,
              oldNum: oldNum || "",
              // oldNum: 0
            }
          }

          // 是否添加员工
          if (project.employeeList) {
            // 整理员工列表数据 根据用户所选的员工数据进行添加
            params.employeeAppointDTOList = project.employeeList.map((item, index) => {
              return {
                employeeId: item.id, // 员工id
                employeeNo: item.employeeNo, // 员工号
                appoint: item.appoint, // 是否指定非指定
                workType: ((index) => {
                  // 工作类型
                  if (item.workTypeName) return item.workTypeName
                  if (index === 0) return '大工'
                  if (index === 1) return '中工'
                  if (index === 2) return '小工'
                })(index),
                sell: null, // 手动设置 销售
                work: null // 手动设置 劳动
              }
            })
          }
          // 发送请求计算当前订单结算价
          await this.API.paperless.calculatingProjectAmount(params).then((res) => {
            this.orderPrice = res
          })
          if (this.orderPrice.code === 0) resolve(this.orderPrice.data) // 返回结算价数据
        })
      },
      // 结算
      async closeAnAccount() {
        // 结算订单判断当前订单数据
        if (this.orderData.length <= 0) {
          this.$message.warning('请添加项目')
          return Promise.resolve(false)
        }
        await this.$refs.orderPending.getEmployeeRoyaltyAuthorityData() // 获取员工提成数据
        this.drawerType = 3 // 打开结算抽屉
        if (this.currentSelectedMember.id) this.orderTypes = 30
        // 判断是散客结算40 还是 会员结算30
        else this.orderTypes = 40
        this.drawer = true // 打开抽屉
        this.orderData = this.deepCopy(this.orderData) // 强制更新一下数据
        this.$refs.orderPending.principalGrantAllocation() // 分配赠金本金
        !this.currentSelectedMember.id && this.$refs.orderPending.defaultPaymentMethodSettings() // 非会员信息自动添加微信支付方式
        this.monitorCarriageReturnPayment(this.$refs.orderPending.tallyOrder, 2) // 开启监听2次回车结算
        console.log('结算执行')
        // 整理支付订单请求体参数
        // 获取当前所选的卡
        let memberCardId = ''
        if (this.currentlySelectedCard) {
          memberCardId = this.currentlySelectedCard.tmemberCard ? this.currentlySelectedCard.tmemberCard.id : ''
        }
        // 挂单
        let param = {
          consumeDTO: {
            consumerItemDTOList: [],
            memberId: this.currentSelectedMember ? this.currentSelectedMember.id : '',
            memberCardId // 当前所选卡项
          },
          orderType: 40
        }
        // 参数
        this.orderData.forEach((orderItem) => {
          const { price, id: itemId, packageName, costPrice } = orderItem
          let data = {
            costPrice: costPrice,
            num: 1,
            originPrice: price,
            itemId,
            itemType: packageName ? 0 : 1, // 0项目 1产品
            employeeAppointDTOList: []
          }
          param.consumeDTO.consumerItemDTOList.push(data)
        })
        console.log('param', param)
        // // 获取部门业绩;
        this.API.goods.getDepartmentalPerformance(param).then((res) => {
          console.log(res.data, 'data')

          this.DepartmentalPerformance = res.data
          if (!this.isFocusedAndBlurred) {
            for (let i = 0; i < this.DepartmentalPerformance.length; i++) {
              this.isDepartmentalPerformance.push({
                achievement: 0,
                departmentId: this.DepartmentalPerformance[i].departmentId,
                departmentName: this.DepartmentalPerformance[i].departmentName,
                unAchievement: this.DepartmentalPerformance[i].unAchievement
              })
            }
            this.isFocusedAndBlurred = true
          }
          if (res.data[res.data.length - 1].unAchievement > 0) {
            this.DepartmentInput = true
            let index = res.data.length - 1
            this.unassigned = res.data[index].unAchievement
            this.performance = res.data[index].unAchievement
          } else {
            this.DepartmentInput = false
            return res.data.map((item) => {
              return [(this.unassigned = item.achievement), (this.performance = item.achievement)]
            })
          }
        })
      },
      // 重新项目更新oldNum值
      async orderOldNumRefresh(currentOrderData) {
        if (!this.currentlySelectedCard || !this.currentlySelectedCard.tmemberCard || this.currentlySelectedCard.tmemberCard.cardTypeName !== '次卡') return currentOrderData

        let itemNum = 0
        let classNum = 0
        for (let i = 0; i < currentOrderData.length; i++) {
          const packageData = {
            isDiscount: false,
            oldNum: -1,
            num: 0,
            oldPackageId: '',
            newPackageId: currentOrderData[i].id,
            memberCardId: this.currentlySelectedCard.tmemberCard.id
          }

          const { data } = await this.API.order.getPackageNew(packageData)
          let packType = 0 // 0 不耗卡 1 项目耗卡 2 项目类别耗卡
          if (!data.flag && data.discount) {
            packType = 1
          }

          if (data.flag && data.discount) {
            currentOrderData[i]._classTypeId = data.classType
            packType = 2
          }
          if (packType === 0) continue;
          if (packType === 1 && data.packageId == currentOrderData[i].id) {
            currentOrderData[i]._itemIndex = ++itemNum
            continue;
          }
          if (packType === 2 && data.classType == currentOrderData[i]._classTypeId) {
            currentOrderData[i]._itemIndex = ++classNum
          }
        }

        return currentOrderData
      },
      // 全订单业绩重算
      async fullOrderPriceRefresh(isoriginalPriceOrNot) {
        // isoriginalPriceOrNot  这个参数只有点头像取消会员卡的时候传递  这就是一坨大便需求拉出来的
        // console.log("存储时的数据", this.orderData);
        this.currentOrderData = await this.orderOldNumRefresh(this.deepCopy(this.orderData)) // 存储当前订单信息
        this.orderData = []
        let array = []
        console.log('订单业绩结算时的this.currentOrderData', this.currentOrderData)
        // 重新计算业绩
        const promiseOrder = this.currentOrderData.map((item) => {
          console.log('传递过来获取的的挂单数据', item)
          let items = this.deepCopy(item)
          // items.originPrice = item.amount
          items.originPrice = item.price
          // items.price = item.amount
          items.price = item.price
          console.log('传递过来获取的的挂单数据2', items)

          let promise = ''
          // 点击头像取消会员卡选择 从新计算，不传递结算价格
          if (isoriginalPriceOrNot) {
            // items
            console.log('点击头像取消会员卡选择 从新计算，不传递结算价格')
            promise = this.calculateProjectPrice(items, true, '', true, false)
          }
          // 判断有会员卡 没有挂单 不可以给结算价
          if (this.currentlySelectedCard && !this.memberWhenPickingUpAnOrder) {
            console.log('判断有会员卡 没有挂单 不可以给结算价')
            promise = this.calculateProjectPrice(items, true, item.tota, true, false)
          }
          // 初始的 取单的时候没有会员卡
          if (!this.memberWhenPickingUpAnOrder && !this.currentlySelectedCard && !isoriginalPriceOrNot) {
            console.log('初始的 取单的时候没有会员卡')
            promise = this.calculateProjectPrice(items, true, item.total, true, false)
          }
          // 判断取单的时候 有会员卡  但是要传递记录的结算价格
          if (this.memberWhenPickingUpAnOrder && this.currentlySelectedCard) {
            console.log('判断取单的时候 有会员卡 ', item.total)
            promise = this.calculateProjectPrice(items, true, item.total, true, false)
          }
          // else{
          //     console.log('给结算价');
          //     promise = this.calculateProjectPrice(items,true,item.total)
          // }

          array.push(items)
          console.log(array, 'array')
          this.orderData.push(items) // 计算完成一个订单存储一次

          return promise
        })
        // 这个是每次判断之后之后才清空memberWhenPickingUpAnOrder
        this.memberWhenPickingUpAnOrder = ''
        promiseOrder.length &&
          Promise.all(promiseOrder).then((result) => {
            // console.log("内部", result);
            result.forEach((item, index) => {
              this.$set(this.orderData[index], 'costPrice', item.costPrice) // 结算价
              this.$set(this.orderData[index], 'originPrice', item.originPrice) // 原价
              this.$set(this.orderData[index], 'total', item.total) // 合计价
              this.$set(this.orderData[index], 'isDiscount', item.isDiscount) // 项目是否折扣
              this.$set(this.orderData[index], 'price', item.originPrice) // 修改原价
              this.setProjectPrice.modifiedDiscount = 10
              // console.log("存储数据this.orderData", this.orderData);
              this.orderData[index].employeeList.forEach((subItem) => {
                const { consumeOrderEmployeeBrokerageVOS } = item
                consumeOrderEmployeeBrokerageVOS.forEach((threeLevel) => {
                  if (subItem.id === threeLevel.employeeId && subItem.employeeNo === threeLevel.employeeNo && subItem.workTypeName === threeLevel.workType) {
                    subItem.sell = threeLevel.sell || 0 // 销售业绩
                    subItem.work = threeLevel.work || 0 // 劳动业绩
                    subItem.appoint = threeLevel.appoint || 0 // 指定 非指定
                    subItem.workType = threeLevel.workType // 劳动类型
                  } else if (subItem.id === threeLevel.employeeId && subItem.employeeNo === threeLevel.employeeNo && this.analyticalDataCommodity(this.orderData[index]) === '1') {
                    subItem.sell = threeLevel.sell || 0 // 销售业绩
                    subItem.work = threeLevel.work || 0 // 劳动业绩
                    subItem.appoint = threeLevel.appoint || 0 // 指定 非指定
                    subItem.workType = threeLevel.workType // 劳动类型
                  }
                })
              })
            })
            // 更新节点数据
            this.stylesAreHighlyAdaptive()
          })
        // console.log("执行", promiseOrder);
      },
      // 检测是否可以进行结算价格修改
      modifiedSettlementPrice(project, index) {
        console.log('修改结算价--------------', project)
        this.whetherTheSettlementPriceCanBeModified = false
        // project -> 当前所选项目
        // 判断当前卡项是否是次卡或者个性次卡 如果是的话还需要判断是否可以进行项目结算价修改
        const { packageName, total, price, originPrice } = project
        let projectOrNot = packageName ? 0 : 1 // 0项目 1产品
        let isInclude = false

        // 次卡判断
        if (this.currentlySelectedCard) {
          const { cardDetail, tmemberCard } = this.currentlySelectedCard
          const { cardTypeCode } = tmemberCard
          if (cardTypeCode === 3 || cardTypeCode === 0) {
            let type = projectOrNot === 0 ? 'package' : 'product'
            // 循环判断当前所选项目是否包含在次卡内
            cardDetail.forEach((item) => {
              if (item.cardName === project[`${type}TypeName`] || item.cardName === project[`${type}Name`]) isInclude = true
            })
          }
        }

        // 不可修改条件 项目必须包含在卡内 并且结算价不为0
        if (isInclude && total === 0) {
          this.$message.warning('次卡不可修改结算价')
        } else {
          this.inputEquipmentShow = true // 开启结算价修改窗口
          this.setProjectPrice.modifiedOriginalPrice = price // 原价
          this.setProjectPrice.originalProjectPrice = price // 原始价格
          this.setProjectPrice.setProjectIndex = index // 存储项目下标

          // 结算价计算
          this.setProjectPrice.modifiedDiscount = this.reverseDiscountSettlementPrice(price, total) // 结算价
          this.setProjectPriceFocus() // 聚焦
          this.$nextTick(() => {
            this.$refs.costFocusRef.focus()
          })
        }
      },
      // 反推折扣结算价
      reverseDiscountSettlementPrice(price, total) {
        // 判断是否开启四舍五入
        const whetherToActivateTheRadiantFive = JSON.parse(window.localStorage.getItem('tenant')).roundOffState !== 0
        if (whetherToActivateTheRadiantFive) {
          total = Math.round(total)
        }
        console.log('开始反推', price, total)
        let discountResult = this.roundFixed(((total / price) * 10).toFixed(3), 2)
        console.log('反推结果', discountResult)
        // 折扣 = 现价 / 原价
        return discountResult.toString() === 'Infinity' || discountResult.toString() === 'NaN' ? 0 : discountResult
      },
      // 聚焦修改结算价输入input
      setProjectPriceFocus($event) {
        this.isSelectStatus = true
        this.noDisplay() // 禁止展示查询项目
        $event && (this.setProjectRefIndex = $event.target.dataset.setprojectindex * 1)
      },
      // 输入设备键盘监听

      setProjectPriceKeydow($event) {
        this.whetherTheSettlementPriceCanBeModified = true
        if (this.isSelectStatus) {
          this.isSelectStatus = false
          if ($event.target.dataset.type === 'modifiedPrice') {
            this.modifiedPrice = ''
          } else {
            this.setProjectPrice[$event.target.dataset.type] = ''
          }
        }

        if ($event.key === '.') {
          if ($event.target.dataset.type === 'modifiedPrice') {
            if (this.modifiedPrice === 0 || this.modifiedPrice === '0') this.modifiedPrice = 0 + $event.key
            else this.modifiedPrice = this.modifiedPrice + $event.key
          } else {
            if (this.setProjectPrice[$event.target.dataset.type] === 0 || this.setProjectPrice[$event.target.dataset.type] === '0') {
              this.setProjectPrice[$event.target.dataset.type] = 0 + $event.key
            } else this.setProjectPrice[$event.target.dataset.type] = this.setProjectPrice[$event.target.dataset.type] + $event.key
          }
          return
        }

        if ($event.key === 'Backspace') {
          this.$nextTick(() => {
            if (this.setProjectRefIndex === 2) this.modifiedPrice = parseFloat(this.modifiedPrice.toString().substring(this.modifiedPrice.toString().length - 1, 0)) || 0
            else this.setProjectPrice[$event.target.dataset.type] = parseFloat(this.setProjectPrice[$event.target.dataset.type].toString().substring(this.setProjectPrice[$event.target.dataset.type].toString().length - 1, 0)) || 0
          })
          return
        }

        const key = (Number($event.key).toString() !== 'NaN' ? Number($event.key) : '').toString()
        if ($event.target.dataset.type === 'modifiedPrice') {
          if (this.modifiedPrice === '' || this.modifiedPrice === 0 || this.modifiedPrice === '0') {
            this.modifiedPrice = key
          } else this.modifiedPrice = this.modifiedPrice + key
        } else {
          if (this.setProjectPrice[$event.target.dataset.type] === '' || this.setProjectPrice[$event.target.dataset.type] === 0 || this.setProjectPrice[$event.target.dataset.type] === '0') {
            this.setProjectPrice[$event.target.dataset.type] = key
          } else this.setProjectPrice[$event.target.dataset.type] = this.setProjectPrice[$event.target.dataset.type] + key
        }
      },
      // 关闭订单修改器
      setProjectFocusClose() {
        this.setProjectRefIndex = 2
        this.inputEquipmentShow = false
        this.setProjectPrice.modifiedOriginalPrice = 0.0 // 原价
        this.setProjectPrice.originalProjectPrice = 0.0 // 原始价格
        this.setProjectPrice.setProjectIndex = 0 // 修改项目订单下标
      },
      // 业绩修改设备输入
      modifyThePriceInputDevice($event) {
        const { number } = $event.target.dataset
        let type = this.setProjectRefIndex === 0 ? 'modifiedOriginalPrice' : 'modifiedDiscount'
        if (number === undefined) return
        this.whetherTheSettlementPriceCanBeModified = true
        // 回退
        if (number === 'rollback') {
          this.$nextTick((_) => {
            console.log(this.setProjectPrice[type])
            if (this.setProjectRefIndex === 2) this.modifiedPrice = parseFloat(this.modifiedPrice.toString().substring(this.modifiedPrice.toString().length - 1, 0)) || 0
            else this.setProjectPrice[type] = parseFloat(this.setProjectPrice[type].toString().substring(this.setProjectPrice[type].toString().length - 1, 0)) || 0
          })
          return
        }
        // 清空
        if (number === 'clear') {
          if (this.setProjectRefIndex === 2) this.modifiedPrice = 0
          else this.setProjectPrice[type] = 0
          return
        }
        // 确定
        if (number === 'return') {
          this.modifyTheOrderSettlementPrice()
          return
        }
        // 判断是否全选
        if (this.isSelectStatus) {
          this.isSelectStatus = false
          if (this.setProjectRefIndex === 0) {
            if (this.setProjectPrice.modifiedOriginalPrice === '') {
              if (number === '.') this.setProjectPrice.modifiedOriginalPrice = 0 + number
              else this.setProjectPrice.modifiedOriginalPrice = number
            } else if (this.setProjectPrice.modifiedOriginalPrice === 0 || this.setProjectPrice.modifiedOriginalPrice === '0') {
              if (number === '.') this.setProjectPrice.modifiedOriginalPrice = 0 + number
              else this.setProjectPrice.modifiedOriginalPrice = number
            } else this.setProjectPrice.modifiedOriginalPrice = number
          }
          if (this.setProjectRefIndex === 1) {
            if (this.setProjectPrice.modifiedDiscount === '') {
              if (number === '.') this.setProjectPrice.modifiedDiscount = 0 + number
              else this.setProjectPrice.modifiedDiscount = number
            } else if (this.setProjectPrice.modifiedDiscount === 0 || this.setProjectPrice.modifiedDiscount === '0') {
              if (number === '.') this.setProjectPrice.modifiedDiscount = 0 + number
              else this.setProjectPrice.modifiedDiscount = number
            } else this.setProjectPrice.modifiedDiscount = number
          }
          if (this.setProjectRefIndex === 2) {
            if (this.modifiedPrice === '') {
              if (number === '.') this.modifiedPrice = 0 + number
              else this.modifiedPrice = number
            } else if (this.modifiedPrice === 0 || this.modifiedPrice === '0') {
              if (number === '.') this.modifiedPrice = 0 + number
              else this.modifiedPrice = number
            } else this.modifiedPrice = number
          }
        } else {
          if (this.setProjectRefIndex === 0) {
            // this.setProjectPrice.modifiedOriginalPrice = this.setProjectPrice.modifiedOriginalPrice + number
            if (this.setProjectPrice.modifiedOriginalPrice === 0 || this.setProjectPrice.modifiedOriginalPrice === '0') {
              if (number === '.') this.setProjectPrice.modifiedOriginalPrice = this.setProjectPrice.modifiedOriginalPrice + number
              else this.setProjectPrice.modifiedOriginalPrice = number
            } else if (this.setProjectPrice.modifiedOriginalPrice === '') {
              if (number === '.') this.setProjectPrice.modifiedOriginalPrice = 0 + number
              else this.setProjectPrice.modifiedOriginalPrice = number
            } else {
              if (number === '.') {
                this.setProjectPrice.modifiedOriginalPrice = this.setProjectPrice.modifiedOriginalPrice + (this.setProjectPrice.modifiedOriginalPrice.toString().indexOf('.') === -1 ? number : '')
              } else this.setProjectPrice.modifiedOriginalPrice = this.setProjectPrice.modifiedOriginalPrice + number
            }
          }
          if (this.setProjectRefIndex === 1) {
            if (this.setProjectPrice.modifiedDiscount === 0 || this.setProjectPrice.modifiedDiscount === '0') {
              if (number === '.') this.setProjectPrice.modifiedDiscount = this.setProjectPrice.modifiedDiscount + number
              else this.setProjectPrice.modifiedDiscount = number
            } else if (this.setProjectPrice.modifiedDiscount === '') {
              if (number === '.') this.setProjectPrice.modifiedDiscount = 0 + number
              else this.setProjectPrice.modifiedDiscount = number
            } else {
              if (number === '.') {
                this.setProjectPrice.modifiedDiscount = this.setProjectPrice.modifiedDiscount + (this.setProjectPrice.modifiedDiscount.toString().indexOf('.') === -1 ? number : '')
              } else this.setProjectPrice.modifiedDiscount = this.setProjectPrice.modifiedDiscount + number
            }
          }
          if (this.setProjectRefIndex === 2) {
            console.log('计算', this.modifiedPrice, number)
            if (this.modifiedPrice === 0 || this.modifiedPrice === '0') {
              if (number === '.') this.modifiedPrice = this.modifiedPrice + number
              else this.modifiedPrice = number
            } else if (this.modifiedPrice === '') {
              if (number === '.') this.modifiedPrice = 0 + number
              else this.modifiedPrice = number
            } else {
              // 判断是否是浮点数
              if (number === '.') {
                this.modifiedPrice = this.modifiedPrice + (this.modifiedPrice.toString().indexOf('.') === -1 ? number : '')
              } else this.modifiedPrice = this.modifiedPrice + number
            }
          }
        }
      },
      // 修改订单结算价格
      async modifyTheOrderSettlementPrice() {
        if (!this.whetherTheSettlementPriceCanBeModified) return
        const { consumeOrderEmployeeBrokerageVOS, costPrice, total, originPrice, isDiscount } = await this.calculateProjectPrice(this.orderData[this.setProjectPrice.setProjectIndex], false, this.modifiedPrice, false, false)
        // 项目价格计算
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'costPrice', costPrice) // 结算价
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'originPrice', originPrice) // 原价
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'total', total) // 合计价
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'price', this.setProjectPrice.modifiedOriginalPrice) // 修改原价
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'discountNumber', this.setProjectPrice.modifiedDiscount) // 折扣
        this.$set(this.orderData[this.setProjectPrice.setProjectIndex], 'isDiscount', isDiscount) // 是否折扣

        // 计算员工业绩
        this.orderData[this.setProjectPrice.setProjectIndex].employeeList.forEach((item) => {
          consumeOrderEmployeeBrokerageVOS.forEach((subItem) => {
            if (subItem.employeeId === item.id && item.employeeNo === subItem.employeeNo && item.workTypeName === subItem.workType) {
              item.sell = subItem.sell || 0 // 销售业绩
              item.work = subItem.work || 0 // 劳动业绩
              item.appoint = subItem.appoint || 0 // 指定 非指定
              item.workType = subItem.workType // 劳动类型
            } else if (subItem.employeeId === item.id && item.employeeNo === subItem.employeeNo && this.analyticalDataCommodity(this.orderData[this.setProjectPrice.setProjectIndex]) === '1') {
              item.sell = subItem.sell || 0 // 销售业绩
              item.work = subItem.work || 0 // 劳动业绩
              item.appoint = subItem.appoint || 0 // 指定 非指定
              item.workType = subItem.workType // 劳动类型
            }
          })
        })
        // 关闭订单修改
        this.setProjectFocusClose()
      },
      // 清除支付订单
      clearOrderInfo(cardId) {
        this.orderData = [] // 清除支付订单
        this.recordOrNot = '' // 清除录单数据
        this.handBrand = '' // 清除手牌号
        // 支付完成后清除清单在判断是否有无会员信息 如果有弹出提示让顾客选择是否继续会员消费或者切换散客消费
        if (this.currentSelectedMember.id) {
          this.$confirm('此会员是否继续耗卡', '提示', {
            confirmButtonText: '继续耗卡',
            cancelButtonText: '切换散客',
            type: 'success'
          })
            .then((res) => {
              this.selectMemberInformation(this.currentSelectedMember, undefined, cardId) // 刷新会员信息 以及卡信息
            })
            .catch(() => {
              this.research() // 清除会员信息
              this.$message({
                type: 'info',
                message: '已切换散客消费'
              })
            })
        }
        // 页面样式初始化
        this.switchingType({
          id: JSON.parse(window.localStorage.getItem('tenant')).isProductPriority === 0 ? 0 : 1
        }) // 项目类型筛选
        this.projectType = 0 // 项目分类
        this.getTheListOfOrderingData({ bol: false }, true) // 更新挂单数据列表
      },
      // 打开充值页
      async openTheRechargePage() {
        if (this.currentlySelectedCard.tmemberCard.cardTypeCode !== 2) return
        await this.$refs.orderPending.openTransferCard(false, this.currentlySelectedCard.tmemberCard.tenantCardId)
        this.monitorCarriageReturnPayment(this.$refs.orderPending.confirmRecharge) // 回车2次结算
        this.drawerType = 2
        this.drawer = true
      },
      // 会员卡开卡
      async membershipCardOpening(isAddMemberInfo) {
        // 开启加载
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: '加载中',
          background: 'rgba(0, 0, 0, .2)',
          spinner: 'el-icon-loading'
        })
        console.log('是否添加顾客信息', isAddMemberInfo)
        isAddMemberInfo && this.$refs.orderPending.addMembershipDetails(this.currentSelectedMember) // 会员信息添加
        await this.$refs.orderPending.openCardDataRequest() // 获取项目数据以及卡数据
        isAddMemberInfo && (await this.$refs.orderPending.anOpenCardItemIsMarked(this.currentSelectedMember.memberMobile)) // 标记会员卡
        this.monitorCarriageReturnPayment(this.$refs.orderPending.payByCard) // 回车2次结账
        this.$nextTick(() => {
          this.drawerType = 4
          this.drawer = true
          loadingInstance.close()
        })
      },
      // 获取门店个性次卡id
      async getTheStorePersonalitySubCardId() {
        const param = {
          tenantId: JSON.parse(window.localStorage.getItem('tenant')).id
        }
        const { data } = await this.API.paperless.getPersonalityCardId(param)
        // 判断当前店铺是否开通个性次卡
        if (data) {
          window.localStorage.setItem('tenantCardId', data)
        } else {
          const { data } = await this.API.paperless.postTenantCardOnegx({
            createBrokerageLevel: 'base',
            createBrokerage: '0.00',
            createBrokerageType: 1,
            rechargeBrokerageLevel: 'base',
            rechargeBrokerage: '0.00',
            rechargeBrokerageType: 1,
            brokerageLevels: [
              {
                itemType: 'MEMBER_CAR_RECHARGE',
                salesNotAppointBrokerage: '0.00',
                salesNotAppointBrokerageType: 1,
                employeeLevel: 'middle'
              },
              {
                itemType: 'MEMBER_CAR_RECHARGE',
                salesNotAppointBrokerage: '0.00',
                salesNotAppointBrokerageType: 1,
                employeeLevel: 'high'
              },
              {
                itemType: 'MEMBER_CAR_CREATE',
                salesNotAppointBrokerage: '0.00',
                salesNotAppointBrokerageType: 1,
                employeeLevel: 'middle'
              },
              {
                itemType: 'MEMBER_CAR_CREATE',
                salesNotAppointBrokerage: '0.00',
                salesNotAppointBrokerageType: 1,
                employeeLevel: 'high'
              }
            ],
            tenantId: localStorage.getItem('tenantId')
          })
          window.localStorage.setItem('tenantCardId', data)
        }
      },
      // 更新会员信息
      updateMemberInformation({ value, type }) {
        this.currentSelectedMember[type] = value
      },
      // 刷新服务器时间
      async updateTime() {
        try {
          const res = await this.API.workbench.getServerTime()
          if (res.data) {
            this.localServerTime = {
              date: res.data[0],
              timestamp: res.data[1]
            }
            localStorage.setItem('serverTime', JSON.stringify(this.localServerTime))
          }
        } catch (e) {
          // 防止获取不到时间: 使用客户端本地时间
          const now = new Date()
          const yyyy = now.getFullYear()
          const mm = String(now.getMonth() + 1).padStart(2, '0')
          const dd = String(now.getDate()).padStart(2, '0')
          const dateStr = `${yyyy}-${mm}-${dd} 00:00:00`
          this.localServerTime = {
            date: dateStr,
            timestamp: now.getTime()
          }
          localStorage.setItem('serverTime', JSON.stringify(this.localServerTime))
        }
      },
      // 获取挂单数据列表
      getTheListOfOrderingData(obj, istodo) {
        // dataTime 时间 key 指定手牌号查询 bol 是否打开挂单面板 orderClear 是否清除订单数据
        // istodo 是否挂单页面
        // 开启加载效果
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: '加载中',
          background: 'rgba(0, 0, 0, .2)',
          spinner: 'el-icon-loading'
        })
        let dataTime = ''
        let keys = ''
        let bol = true
        let orderClear = true

        // 解析参数
        if (obj) {
          dataTime = obj.dataTime !== undefined ? obj.dataTime : dataTime
          keys = obj.key !== undefined ? obj.key : keys
          bol = obj.bol !== undefined ? obj.bol : bol
          orderClear = obj.orderClear !== undefined ? obj.orderClear : orderClear
        }
        // 时间范围修改
        if (!dataTime) {
          dataTime = []
          dataTime[0] = `${moment(new Date(this.localServerTime.date.split(' ')[0])).format('YYYY-MM-DD')} 00:00:00`
          dataTime[1] = `${moment(new Date(this.localServerTime.date.split(' ')[0])).format('YYYY-MM-DD')} 23:59:59`
        } else {
          dataTime[0] = dataTime[0] += ' 00:00:00'
          dataTime[1] = dataTime[1] += ' 23:59:59'
        }
        // 参数调整
        let param = {
          status: 100,
          pageIndex: 1,
          pageSize: 500,
          startTime: dataTime[0],
          endTime: dataTime[1],
          sort: 2,
          repeat: 2,
          extraNum: 2,
          extraStatue: 1,
          countMemberNum: 0,
          handBrand: keys
        }

        // 查询订单
        this.API.paperless.obtainOrderingData(param).then((res) => {
          // 过滤出所有项目产品订单
          this.orderDataHasBeenPosted = res.data.pageInfo.list.filter((item) => {
            this.$set(item, 'sign', false)
            return item.orderType === 40
          })
          // 如果有手牌号参数的
          if (!res.data.pageInfo.list.length && keys) {
            this.$message.warning('查无此水牌号订单')
          }

          !istodo && this.$refs.orderPending.openOrderTiming() // 开启时间计算
          !istodo && this.scannerGunListening(this.$refs.orderPending.monitorScannerGunCheckList)

          // 延迟400毫秒一下 稍微让页面加载一下 不然请求后计算速度太快加载刚出来就没了 就会一闪而过
          setTimeout(() => {
            // 搜索完成判断是否取单
            if (obj && obj.takeTheOrder && res.data.pageInfo.list.length) {
              this.$refs.orderPending.automaticOrderCollection()
            }

            this.$nextTick(() => {
              loadingInstance.close() // 关闭加载效果

              // 是否清除旧的订单数据
              if (orderClear) {
                // console.log('是否清除旧的订单数据');
                this.orderData = [] // 清除旧的订单数据
                this.currentOrderData = [] // 清除旧的订单数据
              }
              if (bol) {
                this.theHandNumberPopsUp = false // 关闭手牌号筛选框
                this.drawerType = 1
                this.drawer = true
              }
            })
          }, 400)
        })
      },
      // 获取挂单单数
      async getThePendingOrderNumber(clearAnOrder) {
        const { data } = await this.API.paperless.getPendingPaymentOrders()
        this.orderDataNumber = data
        this.occupied = [] // 清空已占用手牌号
        if (clearAnOrder) {
          // 清除订单数据
          this.orderData = [] // 清除旧的订单数据
          this.currentOrderData = [] // 清除旧的订单数据
        }
      },
      // 选择手牌号
      async selectTheHandNumber(key) {
         console.log('=== selectTheHandNumber 触发，key:', key, '时间:', Date.now())
        if (key === '') return // 如果键值为空 则返回
        // 判断当前手牌号是否被占用 如果占用则退出
        if (this.returnStyleDisplay(key)) return this.$message.warning('手牌号已被占用')
        this.occupied.push(key) // 添加到已占用列表当中
        // 获取当前所选的卡
        let memberCardId = '' // 卡项id
        if (this.currentlySelectedCard) {
          memberCardId = this.currentlySelectedCard.tmemberCard ? this.currentlySelectedCard.tmemberCard.id : ''
        }
        // 调用接口进行挂单
        let param = {
          remark: '',
          orderType: 40,
          consumeDTO: {
            consumerItemDTOList: []
          },
          totalAmount: 0,
          memberId: this.currentSelectedMember ? this.currentSelectedMember.id : '',
          handBrand: key, // 手牌号
          memberCardId // 会员卡id
        }
        // 挂单接口
        console.log('挂单数据列表', this.orderData)
        param.consumeDTO.consumerItemDTOList = this.orderData.map((orderItem) => {
          const { price, id: itemId, packageName, costPrice } = orderItem
          param.totalAmount = this.accuracyCheck(param.totalAmount, price)
          return {
            costPrice: costPrice,
            num: 1,
            originPrice: price,
            itemId,
            itemType: packageName ? 0 : 1, // 0 项目 1 产品
            employeeAppointDTOList: orderItem.employeeList.map((employeeItem) => {
              const { workType, id: employeeId, appoint } = employeeItem
              return {
                workType,
                employeeId,
                appoint: appoint || 0
              }
            })
          }
        })
        console.log('>>> 即将调用 orderPlacement，参数:', param)
        let { code } = await this.API.paperless.orderPlacement(param)
        console.log('>>> orderPlacement 返回:', code)
        if (code === 0) {
          if (JSON.parse(window.localStorage.getItem('tenant')).isAutomaticInput === 0) this.$message.success('挂单成功')
          else this.$message.success(`自动挂单${key}号成功`)
          this.$refs.employeeRef.style.transform = 'translateX(520px)'
          this.research() // 清除用户数据
          this.getTheListOfOrderingData() // 获取订单数据
        }
      },
      // 修改删除单挂单
      async upDataSelectTheHandNumber(orderId) {
        // 获取当前所选的卡
        let memberCardId = ''
        if (this.currentlySelectedCard) {
          memberCardId = this.currentlySelectedCard.tmemberCard ? this.currentlySelectedCard.tmemberCard.id : ''
        }
        // 挂单
        let param = {
          remark: '',
          consumeDTO: {
            consumerItemDTOList: []
          },
          totalAmount: 0,
          memberId: this.currentSelectedMember ? this.currentSelectedMember.id : '',
          orderId,
          memberCardId // 当前所选卡项
        }
        // 挂单接口
        param.consumeDTO.consumerItemDTOList = this.orderData.map((orderItem) => {
          const { price, id: itemId, packageName, costPrice } = orderItem
          param.totalAmount = this.accuracyCheck(param.totalAmount, price)
          return {
            costPrice: costPrice,
            num: 1,
            originPrice: price,
            itemId,
            itemType: packageName ? 0 : 1, // 0项目 1产品
            employeeAppointDTOList: orderItem.employeeList.map((employeeItem) => {
              const { workType, id: employeeId, appoint } = employeeItem
              return {
                workType,
                employeeId,
                appoint: appoint || 0
              }
            })
          }
        })
        // console.log("挂单接口请求参数", param);
        let { code } = await this.API.paperless.updateHangOrderInfo(param)
        if (code === 0) {
          this.$message.success('挂单成功')
          this.$refs.employeeRef.style.transform = 'translateX(520px)'
          this.recordOrNot = '' // 清空单号
          this.research() // 清除会员信息
          this.getTheListOfOrderingData() // 获取订单数据
        }
      },
      // 挂单函数
      async pendingOrderList() {
        console.log('=== pendingOrderList 触发，时间:', Date.now())
         //  加锁：正在挂单中，忽略后续点击
        if (this._hangOrderLock) {
          console.log('挂单进行中，忽略重复点击')
          return
        }
        this._hangOrderLock = true
      try{
        if (!this.orderData.length) return this.$message.warning('请添加项目')
        console.log(this.orderData, '订单的钱.......')
        this.occupied = [] // 清除残留挂单信息
        // 判断是自动添加手牌号还是手动添加
        let tenant = JSON.parse(window.localStorage.getItem('tenant'))
        // 判断当前订单是否是挂单数据
        if (this.recordOrNot) {
          // 更新修改挂单数据接口
          // console.log('this.recordOrNot更新修改挂单数据接口',this.recordOrNot);
          await this.upDataSelectTheHandNumber(this.recordOrNot)
          return
        }
        // 0手动添加 1自动添加
        if (tenant.isAutomaticInput === 0) {
          // 获取已占用手牌号信息
          //  console.log('------------------tenant.isAutomaticInput');
          const { data } = await this.API.paperless.theNumberOfTheCurrentlyOccupiedHandObtained()
          this.occupied = data
          this.theHandNumberPopsUp = true // 打开手牌号筛选框
        } else {
          //  console.log('tenant.isAutomaticInput------------------');
          const { data } = await this.API.paperless.getAnUnoccupiedHan()
          await this.selectTheHandNumber(data)
        }
      }finally {
        this._hangOrderLock = false   //  无论成功失败都解锁
      }
      },
      // 判断当前手牌号是否被占用
      returnStyleDisplay(key) {
        return this.occupied.indexOf(key) !== -1
      },
      // 更新挂单状态
      updateTag(itemId) {
        this.orderDataHasBeenPosted.forEach((item) => item.id === itemId && (item.sign = !item.sign))
      },
      // 选单添加到订单数据中
      updateOrderData({ orderList, memberInfo, memberCardId }) {
        // console.log("所传递订单信息", orderList, memberInfo, memberCardId);
        this.recordOrNot = orderList[0].orderId // 记录订单单号
        this.handBrand = orderList[0].handBrand // 手牌号

        this.orderData = orderList
        console.log('取单回调函数', this.orderData)

        // 赋值到当前订单数据
        if (memberInfo) {
          this.memberWhenPickingUpAnOrder = '取单时有会员信息'
          // 根据会员信息重新计算项目价格
          this.selectMemberInformation(memberInfo, undefined, memberCardId)
        } else {
          this.memberWhenPickingUpAnOrder = ''
          this.$nextTick(() => {
            // 重置会员数据 重新计算项目价格
            this.research()
          })
        }
        setTimeout(() => {
          this.stylesAreHighlyAdaptive() // 更新节点数据
        }, 100)
      },
      // 跳转详情页用户信息
      jumpDetails() {
        const { id, memberMobile, wechatOpenId } = this.currentSelectedMember
        let query = {
          id,
          phone: memberMobile,
          openid: wechatOpenId,
          state: 1
        }
        // 路由地址跳转
        const routeData = this.$router.resolve({
          name: 'homeMemberItemDetail',
          query
        })
        this.openWindows(routeData)
      },
      // 打开新窗口
      openWindows(routeData) {
        window.open(routeData.href, '_blank', 'height=700, width=1200, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no,alwaysRaised=yes,z-look=yes')
      },
      // 全屏模式
      Fkey() {
        if (!this.flag) {
          let el = document.documentElement
          let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
          if (typeof rfs != 'undefined' && rfs) {
            rfs.call(el)
            this.flag = true
          }
        } else {
          let el = document
          let cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen
          if (typeof cfs != 'undefined' && cfs) {
            cfs.call(el)
            this.flag = false
          }
        }
      },
      // 更新卡备注
      async updateCardRemarks() {
        if (this.cardNoteContent === '') return this.$message.warning('备注信息不能为空')
        let param = {
          id: this.currentlySelectedCard.tmemberCard.id,
          remark: this.cardNoteContent
        }
        await this.API.paperless.withTheNewCardInformation(param)
        this.currentlySelectedCard.tmemberCard.remark = this.cardNoteContent
        this.$message.success('卡信息更新成功')
        this.cardRemarks = false
      },
      // 结算页面更新指定非指定
      setModifyADesignation({ projectItem, employeeItem }) {
        console.log('点击', projectItem, employeeItem)
        this.modifyADesignation(projectItem, employeeItem)
      },
      // 取消录单
      cancelBooking() {
        // 清空订单单号
        this.orderData = []
        this.research()
        this.recordOrNot = ''
      },
      // 修改积分
      modifiedIntegral(modifyType) {
        this.modifyData = true // 打开积分修改
        this.modifyType = modifyType // 修改类型
        // 积分聚焦
        this.$nextTick(() => {
          this.$refs.integral.$refs.integralFocusing.focus()
        })
      },
      // 发送请求修改积分
      setIntegral(newValue) {
        console.log('积分发生变化', newValue)
        if (!newValue) return
        if (this.modifyType === 'remove' && newValue > this.currentSelectedMember.pointValue) return this.$message.warning('扣除积分不可大于剩余积分')
        let param = {
          memberId: this.currentSelectedMember.id,
          point: newValue,
          type: this.modifyType === 'add' ? '手动增加' : '消耗'
        }

        this.API.paperless.manualModificationOfIntegral(param).then((res) => {
          if (res.data) {
            this.$message.success('修改成功')
            this.modifyType === 'add' ? (this.currentSelectedMember.pointValue = this.accuracyCheck(this.currentSelectedMember.pointValue, newValue)) : (this.currentSelectedMember.pointValue = this.accuracyCheck(this.currentSelectedMember.pointValue, newValue, '-'))

            this.modifyData = false // 关闭
          }
        })
      },
      // 店铺全局设置
      storeGlobalSettingStatus(type) {
        return this.currentStoreGlobalSettings.some((item) => item.dictName === type && item.dictValue === '1')
      },
      // 打开备注修改
      openRemarksModification() {
        this.cardRemarks = true
        this.cardNoteContent = this.currentlySelectedCard.tmemberCard.remark
        // 卡备注聚焦
        this.$nextTick(() => {
          this.$refs.remark.focus()
        })
      },
      // 关闭手牌号
      closeTheHandNumber() {
        this.customizeTheHandNumber = ''
        this.theHandNumberPopsUp = false
      },
      // 锁定系列表
      lockingSeries(seriesId, itemID, e) {
        console.log('开始锁定', seriesId, itemID, e)
        this.projectTypeList.forEach((item, index) => {
          if (item.id === seriesId) {
            this.projectType = index
          }
        })
        this.letter = '' // 字母筛选条件清空
        if (e.detail !== 2) {
          this.screeningItem() // 筛选项目
        };

        if (itemID) {
          console.log(this.projectList)
          let pItem = {}
          let index = 0
          this.projectList.forEach((projectItem, projectIndex) => {
            if (projectItem.id === itemID) {
              this.theProjectSelectsGlobalListening = projectIndex
              pItem = projectItem
              index = projectIndex
            }
          })

          if (e.detail === 2) {
            this.option(pItem, undefined, index)
          }
        } else this.theProjectSelectsGlobalListening = ''
      },
      // 锁定系列表-触摸双击触发
      handleTouchStart(seriesId, itemID, event, index) {
        event.stopPropagation();

        const currentTime = Date.now();

        // 如果正在处理或者100ms内连续点击，直接返回
        if (this.tapLock || (currentTime - this.lastTapTime < 100)) {
          return;
        }

        // 超过双击间隔或点击不同项目则重置计数
        if (currentTime - this.lastTapTime > this.doubleTapDelay || this.currentTapIndex !== index) {
          this.tapCount = 0;
        }

        // 如果正在处理点击，直接忽略后续事件
        if (this.isProcessingTap) return;

        // 清除之前的定时器（防止多次触发）
        if (this.tapTimer) {
          clearTimeout(this.tapTimer);
          this.tapTimer = null;
        }

        this.tapCount++;
        this.currentTapIndex = index;

        if (this.tapCount > 2) {
          this.tapCoun = 0
        }

        // 如果是第二次点击且在允许的时间范围内
        if (this.tapCount === 2 && this.isWaitingSecondTap && currentTime - this.lastTapTime < this.doubleTapDelay) {
          this.tapCount = 0
          this.isWaitingSecondTap = false; // 标记已处理
          this.isProcessingTap = true;     // 锁定处理状态

          // 执行双击逻辑
          this.processDoubleTap(seriesId, itemID);
          event.preventDefault(); // 仅在双击时阻止默认行为
          // 250ms 后解锁（防止短时间内再次触发）
          setTimeout(() => {
            this.isProcessingTap = false;
          }, this.doubleTapDelay);
        }
        // 否则视为第一次点击
        else {
          this.isWaitingSecondTap = true;
          this.lastTapTime = currentTime;

          // 设置超时，如果超过 `doubleTapDelay` 没有第二次点击，则视为单击
          this.tapTimer = setTimeout(() => {
            this.isWaitingSecondTap = false;
            this.tapTimer = null;
          }, this.doubleTapDelay);
        }
      },

      processDoubleTap(seriesId, itemID) {
        // 你的双击处理逻辑
        console.log("✅ 双击触发", seriesId, itemID);

        this.projectTypeList.forEach((item, index) => {
          if (item.id === seriesId) {
            this.projectType = index;
          }
        });

        this.letter = '';
        this.screeningItem();

        if (itemID) {
          let pItem = {};
          let index = 0;
          this.projectList.forEach((projectItem, projectIndex) => {
            if (projectItem.id === itemID) {
              this.theProjectSelectsGlobalListening = projectIndex;
              pItem = projectItem;
              index = projectIndex;
            }
          });
          this.option(pItem, undefined, index);
        } else {
          this.theProjectSelectsGlobalListening = '';
        }
      },
      // 扫码枪监听触发
      async monitorTrigger(keys, option) {
        console.log('监听触发', keys)
        // 判断当前订单是否是挂单数据 如果是挂单数据就禁止继续扫码挂单
        if (this.recordOrNot) return
        let key = keys[keys.length - 3] + keys[keys.length - 2] + keys[keys.length - 1]
        if (this.drawerType !== 0) return // 只能在首页进行手牌号挂单
        if (!this.orderData.length) return this.$message.warning('请添加项目')
        await this.selectTheHandNumber(key)
      },
      // 过滤项目数据
      filterItemData() {
        // 如果查询条件为空 则恢复默认
        if (!this.queryItem) {
          this.projectTypeList[0].dictName === '全部' && this.projectTypeList.splice(0, 1)
          this.projectType = 0
          this.switchItems(this.projectTypeList[0], 0) // 默认查询
          return
        }
        // 根据标识查询相关项目
        let filterOutItem = this.allProjectList.filter((item) => {
          let code = item.productCode ? item.productCode.substring(0, this.queryItem.length) : item.packageCode.substring(0, this.queryItem.length)
          // 模糊查询
          return this.queryItem === code
        })
        let exactSort = []
        // 精准排序
        for (let i = 0; i < filterOutItem.length; i++) {
          let code = filterOutItem[i].productCode ? filterOutItem[i].productCode : filterOutItem[i].packageCode
          if (code === this.queryItem) {
            exactSort.unshift(filterOutItem[i])
          } else {
            exactSort.push(filterOutItem[i])
          }
        }

        // 判断是否过滤出项目
        if (exactSort.length) {
          console.log('符合条件项目', exactSort)
          this.projectTypeList[0].dictName !== '全部' &&
            this.projectTypeList.unshift({
              dictName: '全部',
              dictValue: '全部'
            })
          this.projectList = exactSort
          this.projectType = 0
        } else {
          this.projectList = []
        }
      },
      // 选择首位项目
      selectFirstItem() {
        // 查询项目回车进行选择项目
        if (!this.searchInputBoxShow) return
        if (this.projectList.length) {
          this.option(this.projectList[0], undefined, 0)
          this.openProjectQuery(false)
        }
      },
      // 禁止展示查询项目
      noDisplay() {
        this.queryItem = '禁止'
      },
      // 允许展示查询项目
      permittedDisplay() {
        this.queryItem = ''
      },
      // 切换项目显示
      switchDisplay() {
        this.$nextTick(() => {
          this.isPic = !this.isPic
          window.localStorage.setItem('isPic', this.isPic)
        })
      },
      // 打卡功能
      turnOnTheClock() {
        // 先执行第一遍
        this.getQRCodeAddress()

        // 打开计时器
        this.timer = setInterval(() => {
          this.getCurrentTime()
        }, 1000)

        // 每5秒刷新一次二维码
        this.twoDimensionalCodeTimer = setInterval(() => {
          this.getQRCodeAddress()
        }, 5000)

        // 打卡功能
        this.punchTheWindow = true
      },
      // 关闭计时器
      turnOffTimer() {
        console.log('关闭计时器')
        clearInterval(this.timer)
        clearInterval(this.twoDimensionalCodeTimer)
      },

      // 获取二维码地址
      getQRCodeAddress() {
        this.API.workbench.getWechatPunchQRCode().then((res) => {
          console.log('请求结果', res.data)
          this.wechatAddress = res.data
        })
      },
      // 获取当前时间
      getCurrentTime() {
        this.API.workbench.getServerTime().then((res) => {
          let serverTime = {
            date: res.data[0],
            timestamp: res.data[1]
          }
          this.localServerTime = serverTime
          window.localStorage.setItem('serverTime', JSON.stringify(serverTime))
        })

        let date = new Date(this.localServerTime.date)
        let weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        let time = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
        let minute = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
        let second = date.getSeconds() <= 9 ? '0' + date.getSeconds() : date.getSeconds()
        let month = date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        let day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
        let week = weekDays[date.getDay()]
        this.$nextTick(() => {
          Object.assign(this.currentTime, {
            time,
            minute,
            second,
            month,
            day,
            week
          })
        })
      },
      // 更新部门业绩数据
      updateDepartmentalList(newVal) {
        this.DepartmentalPerformance = newVal
        // 开卡/充值用的部门业绩也一并清零（它全页面只初始化一次，别处不会再重置）
         this.isDepartmentalPerformance.forEach((item) => (item.achievement = 0))
      }
    }
  }
  </script>

<style lang="scss" scoped>
@import "./index.scss";

.jobList_item.highlight-job {
  background-color: #fff3cd; // 淡黄色背景
  border: 1px solid #ffc107; // 金色边框
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(255, 193, 7, 0.3); // 轻微发光
  transition: all 0.2s ease;
}

/deep/ .el-skeleton {
  margin-top: 15px !important;
}

// 二维码打卡样式 后面加
/deep/ .punchQRCode {
  width: 100%;

  .currentDate {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .time_box {
      font-size: 32px;
      font-weight: bold;
    }
  }

  .qrCode {
    width: 100%;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .twoDimensionalCodeDisplay {
      width: 300px;
      height: 300px;
      margin-bottom: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .hint {
      .icon {
        .iconfont {
          color: #00c800;
        }
      }
    }
  }
}

.FixedBottom {
  position: absolute;
  bottom: 0;
  /* 固定在底部 */
  width: 100%;
  /* 宽度填满父容器 */
}

.itemQueryCt {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 40px;
  z-index: 99999;
  border-radius: 40px;
  overflow: hidden;
  // background-color: #FFFFFF;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;

  >span {
    white-space: nowrap;
    line-height: 40px;
    color: #939393;
  }

  input {
    width: 150px;
    height: 100%;
    padding: 0 15px;
    font-size: 14px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/paperless/index.vue